/* tslint:disable */
/* eslint-disable */
/**
 * premiosMs
 * API para el microservicio premios
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AsignacionEvaluadorResumen
 */
export interface AsignacionEvaluadorResumen {
    /**
     * 
     * @type {number}
     * @memberof AsignacionEvaluadorResumen
     */
    'convocatoriaId': number;
    /**
     * 
     * @type {number}
     * @memberof AsignacionEvaluadorResumen
     */
    'usuarioId': number;
    /**
     * 
     * @type {string}
     * @memberof AsignacionEvaluadorResumen
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsignacionEvaluadorResumen
     */
    'nombreUsuario': string;
    /**
     * EVALUADOR_INDIVIDUAL o PRESIDENTE_COMISION (puede ser null si no hay registro en usuario_rol)
     * @type {string}
     * @memberof AsignacionEvaluadorResumen
     */
    'rol'?: string;
    /**
     * 
     * @type {number}
     * @memberof AsignacionEvaluadorResumen
     */
    'totalSolicitudes': number;
    /**
     * 
     * @type {number}
     * @memberof AsignacionEvaluadorResumen
     */
    'totalEvaluadas': number;
    /**
     * 
     * @type {number}
     * @memberof AsignacionEvaluadorResumen
     */
    'totalPendientes': number;
    /**
     * 
     * @type {number}
     * @memberof AsignacionEvaluadorResumen
     */
    'totalDesasignadaRechazada': number;
}
/**
 * 
 * @export
 * @interface BitacoraDesfinalizacionEvaluacionIndividual
 */
export interface BitacoraDesfinalizacionEvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof BitacoraDesfinalizacionEvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BitacoraDesfinalizacionEvaluacionIndividual
     */
    'evaluacionIndividualId': number;
    /**
     * 
     * @type {string}
     * @memberof BitacoraDesfinalizacionEvaluacionIndividual
     */
    'comentario': string;
}
/**
 * 
 * @export
 * @interface BitacoraDesfinalizacionEvaluacionPlenaria
 */
export interface BitacoraDesfinalizacionEvaluacionPlenaria {
    /**
     * 
     * @type {number}
     * @memberof BitacoraDesfinalizacionEvaluacionPlenaria
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BitacoraDesfinalizacionEvaluacionPlenaria
     */
    'evaluacionPlenariaId': number;
    /**
     * 
     * @type {string}
     * @memberof BitacoraDesfinalizacionEvaluacionPlenaria
     */
    'comentario': string;
}
/**
 * 
 * @export
 * @interface BitacoraRechazoEvaluacionIndividual
 */
export interface BitacoraRechazoEvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof BitacoraRechazoEvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof BitacoraRechazoEvaluacionIndividual
     */
    'evaluacionIndividualId': number;
    /**
     * 
     * @type {string}
     * @memberof BitacoraRechazoEvaluacionIndividual
     */
    'motivo': string;
    /**
     * 
     * @type {string}
     * @memberof BitacoraRechazoEvaluacionIndividual
     */
    'comentario': string;
    /**
     * 
     * @type {string}
     * @memberof BitacoraRechazoEvaluacionIndividual
     */
    'fechaRechazo'?: string;
}
/**
 * 
 * @export
 * @interface CambioEstatusAsignadaRequest
 */
export interface CambioEstatusAsignadaRequest {
    /**
     * 
     * @type {number}
     * @memberof CambioEstatusAsignadaRequest
     */
    'idEvaluacionIndividual': number;
    /**
     * 
     * @type {string}
     * @memberof CambioEstatusAsignadaRequest
     */
    'comentario'?: string;
}
/**
 * 
 * @export
 * @interface CatEstatusSolicitud
 */
export interface CatEstatusSolicitud {
    /**
     * 
     * @type {number}
     * @memberof CatEstatusSolicitud
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatEstatusSolicitud
     */
    'clave'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatEstatusSolicitud
     */
    'nombre'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatEstatusSolicitud
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface CatalogoDetalle
 */
export interface CatalogoDetalle {
    /**
     * 
     * @type {number}
     * @memberof CatalogoDetalle
     */
    'id'?: number;
    /**
     * 
     * @type {CatalogoMaestro}
     * @memberof CatalogoDetalle
     */
    'catalogoMaestro': CatalogoMaestro;
    /**
     * 
     * @type {string}
     * @memberof CatalogoDetalle
     */
    'clave': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogoDetalle
     */
    'nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogoDetalle
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface CatalogoMaestro
 */
export interface CatalogoMaestro {
    /**
     * 
     * @type {number}
     * @memberof CatalogoMaestro
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogoMaestro
     */
    'clave': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogoMaestro
     */
    'nombre': string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogoMaestro
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface Constancia
 */
export interface Constancia {
    /**
     * 
     * @type {number}
     * @memberof Constancia
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'apellidoPaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'apellidoMaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'curp'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Constancia
     */
    'activated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Constancia
     */
    'idRol'?: number;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'rol'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Constancia
     */
    'miembroComisionPlenaria'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Constancia
     */
    'idConvocatoria'?: number;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'nombreConvocatoria'?: string;
    /**
     * 
     * @type {string}
     * @memberof Constancia
     */
    'descConvocatoria'?: string;
    /**
     * URI del documento de evaluación individual
     * @type {string}
     * @memberof Constancia
     */
    'documentoEvalInd'?: string | null;
    /**
     * URI del documento de comisión/plenaria
     * @type {string}
     * @memberof Constancia
     */
    'documentoEvalComision'?: string | null;
}
/**
 * 
 * @export
 * @interface Convocatoria
 */
export interface Convocatoria {
    /**
     * 
     * @type {number}
     * @memberof Convocatoria
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'nombre': string;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'descripcion': string;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'fechaInicio': string;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'fechaFin': string;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'fechaValidacionDocumental'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'fechaEvaluacion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Convocatoria
     */
    'fechaPublicacionResultados'?: string | null;
}
/**
 * 
 * @export
 * @interface ConvocatoriaEvaluacionResumen
 */
export interface ConvocatoriaEvaluacionResumen {
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'convocatoriaId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'convocatoriaNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'anioConvocatoria'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'fechaSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'curp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'nombreSolicitante'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'nivelSnii'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'descNivelSnii'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'cvuProponente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'nombreProponente'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'estatusSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'institucion'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'totalEvaluadas'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'resultadoEvaluacionesIndividuales'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'evaluacionPlenariaId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'estatusEvaluacionPlenaria'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'resultadoEvaluacionPlenaria'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConvocatoriaEvaluacionResumen
     */
    'posicionPlenaria'?: number | null;
}
/**
 * 
 * @export
 * @interface DatosSolicitud
 */
export interface DatosSolicitud {
    /**
     * 
     * @type {number}
     * @memberof DatosSolicitud
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatosSolicitud
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatosSolicitud
     */
    'semblanza'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosSolicitud
     */
    'evidenciaImpacto'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatosSolicitud
     */
    'institucion'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSolicitud
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface DatosSolicitud2026
 */
export interface DatosSolicitud2026 {
    /**
     * 
     * @type {number}
     * @memberof DatosSolicitud2026
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatosSolicitud2026
     */
    'solicitudId': number;
    /**
     * Semblanza enfatizando relación con el premio (300 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'semblanza': string;
    /**
     * Línea o líneas de investigación actuales (100 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'lineasInvestigacion': string;
    /**
     * Evolución de trayectoria últimos 5-7 años (300 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'trayectoriaEvolucion': string;
    /**
     * Carta de exposición de motivos (300 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'cartaMotivos': string;
    /**
     * Contribuciones científicas más relevantes (450 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'contribucionesClave': string;
    /**
     * Reconocimientos, validaciones o liderazgo en redes (200 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'reconocimientos': string;
    /**
     * Número total por categoría de artículos, libros, ponencias (200 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'produccionCientifica': string;
    /**
     * h-index o equivalente (30 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'hIndex': string;
    /**
     * Proyectos liderados y financiamiento obtenido (500 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'proyectosFinanciados': string;
    /**
     * Innovaciones más relevantes y de mayor impacto (500 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'innovacionImpacto': string;
    /**
     * Acciones de fortalecimiento institucional en México (450 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'fortalecimientoInstitucional': string;
    /**
     * Número de tesis dirigidas (50 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'tesisDirigidas': string;
    /**
     * Resultados relevantes de formación de recursos humanos (200 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'formacionRecursos': string;
    /**
     * Problema específico de salud y bienestar (200 palabras)
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'problemaSalud': string;
    /**
     * 
     * @type {string}
     * @memberof DatosSolicitud2026
     */
    'institucion': string;
    /**
     * 
     * @type {boolean}
     * @memberof DatosSolicitud2026
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface DetalleEvaluacionIndividual
 */
export interface DetalleEvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual
     */
    'evaluacionIndividualId': number;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual
     */
    'resultadoEvaluacion'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionIndividual
     */
    'observaciones'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleEvaluacionIndividual
     */
    'activated'?: boolean;
    /**
     * 
     * @type {EvaluacionIndividual}
     * @memberof DetalleEvaluacionIndividual
     */
    'evaluacionIndividual'?: EvaluacionIndividual;
}
/**
 * 
 * @export
 * @interface DetalleEvaluacionIndividual2026
 */
export interface DetalleEvaluacionIndividual2026 {
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'evaluacionIndividualId': number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'comentario1'?: string;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'puntos1'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'comentario2'?: string;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'puntos2'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'comentario3'?: string;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'puntos3'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'comentario4'?: string;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'puntos4'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'comentario5'?: string;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'puntos5'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'resultadoEvaluacion'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleEvaluacionIndividual2026
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface DetalleEvaluacionPlenaria
 */
export interface DetalleEvaluacionPlenaria {
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionPlenaria
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionPlenaria
     */
    'evaluacionPlenariaId': number;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionPlenaria
     */
    'resultadoEvaluacion'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetalleEvaluacionPlenaria
     */
    'observaciones'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DetalleEvaluacionPlenaria
     */
    'activated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DetalleEvaluacionPlenaria
     */
    'posicion'?: number;
    /**
     * 
     * @type {EvaluacionPlenaria}
     * @memberof DetalleEvaluacionPlenaria
     */
    'evaluacionPlenaria'?: EvaluacionPlenaria;
}
/**
 * 
 * @export
 * @interface Documento
 */
export interface Documento {
    /**
     * 
     * @type {number}
     * @memberof Documento
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Documento
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Documento
     */
    'url'?: string;
    /**
     * 
     * @type {TipoDocumento}
     * @memberof Documento
     */
    'tipoDocumento'?: TipoDocumento;
    /**
     * 
     * @type {TipoArchivo}
     * @memberof Documento
     */
    'tipoArchivo'?: TipoArchivo;
    /**
     * 
     * @type {boolean}
     * @memberof Documento
     */
    'activated'?: boolean;
}
/**
 * Documento a exportar en formato PDF y HTML
 * @export
 * @interface DocumentoExport
 */
export interface DocumentoExport {
    /**
     * MIME type del documento
     * @type {string}
     * @memberof DocumentoExport
     */
    'contentType'?: string;
    /**
     * Contiene el documento en contenidoBase64
     * @type {string}
     * @memberof DocumentoExport
     */
    'contenidoBase64'?: string;
}
/**
 * 
 * @export
 * @interface EstatusEvaluacionIndividual
 */
export interface EstatusEvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof EstatusEvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EstatusEvaluacionIndividual
     */
    'evaluacionIndividualId': number;
    /**
     * 
     * @type {number}
     * @memberof EstatusEvaluacionIndividual
     */
    'catEstatusEvaluacionIndividualId': number;
    /**
     * 
     * @type {boolean}
     * @memberof EstatusEvaluacionIndividual
     */
    'activated'?: boolean;
    /**
     * 
     * @type {EvaluacionIndividual}
     * @memberof EstatusEvaluacionIndividual
     */
    'evaluacionIndividual'?: EvaluacionIndividual;
    /**
     * 
     * @type {CatalogoDetalle}
     * @memberof EstatusEvaluacionIndividual
     */
    'catalogoDetalle'?: CatalogoDetalle;
}
/**
 * 
 * @export
 * @interface EstatusEvaluacionPlenaria
 */
export interface EstatusEvaluacionPlenaria {
    /**
     * 
     * @type {number}
     * @memberof EstatusEvaluacionPlenaria
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EstatusEvaluacionPlenaria
     */
    'evaluacionPlenariaId': number;
    /**
     * 
     * @type {number}
     * @memberof EstatusEvaluacionPlenaria
     */
    'catEstatusEvaluacionPlenariaId': number;
    /**
     * 
     * @type {boolean}
     * @memberof EstatusEvaluacionPlenaria
     */
    'activated'?: boolean;
    /**
     * 
     * @type {EvaluacionPlenaria}
     * @memberof EstatusEvaluacionPlenaria
     */
    'evaluacionPlenaria'?: EvaluacionPlenaria;
    /**
     * 
     * @type {CatalogoDetalle}
     * @memberof EstatusEvaluacionPlenaria
     */
    'catalogoDetalle'?: CatalogoDetalle;
}
/**
 * 
 * @export
 * @interface EstatusSolicitud
 */
export interface EstatusSolicitud {
    /**
     * 
     * @type {number}
     * @memberof EstatusSolicitud
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EstatusSolicitud
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {CatEstatusSolicitud}
     * @memberof EstatusSolicitud
     */
    'catEstatusSolicitud'?: CatEstatusSolicitud;
    /**
     * 
     * @type {boolean}
     * @memberof EstatusSolicitud
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface EvaluacionAsignadaResumen
 */
export interface EvaluacionAsignadaResumen {
    /**
     * 
     * @type {number}
     * @memberof EvaluacionAsignadaResumen
     */
    'idEvaluacionIndividual'?: number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionAsignadaResumen
     */
    'idSolicitud'?: number;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'institucion'?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'nivelSnii'?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'cvuAspirante'?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'nombreAspirante'?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'estatusSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluacionAsignadaResumen
     */
    'estatusEvaluacion'?: string;
}
/**
 * 
 * @export
 * @interface EvaluacionIndividual
 */
export interface EvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof EvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionIndividual
     */
    'solicitudId': number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionIndividual
     */
    'usuarioId': number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionIndividual
     */
    'convocatoriaId': number;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluacionIndividual
     */
    'activated'?: boolean;
    /**
     * 
     * @type {Solicitud}
     * @memberof EvaluacionIndividual
     */
    'solicitud'?: Solicitud;
    /**
     * 
     * @type {Usuario}
     * @memberof EvaluacionIndividual
     */
    'usuario'?: Usuario;
    /**
     * 
     * @type {Convocatoria}
     * @memberof EvaluacionIndividual
     */
    'convocatoria'?: Convocatoria;
    /**
     * 
     * @type {Array<EstatusEvaluacionIndividual>}
     * @memberof EvaluacionIndividual
     */
    'estatusEvaluaciones'?: Array<EstatusEvaluacionIndividual>;
    /**
     * 
     * @type {DetalleEvaluacionIndividual}
     * @memberof EvaluacionIndividual
     */
    'detalleEvaluacion'?: DetalleEvaluacionIndividual;
}
/**
 * 
 * @export
 * @interface EvaluacionPlenaria
 */
export interface EvaluacionPlenaria {
    /**
     * 
     * @type {number}
     * @memberof EvaluacionPlenaria
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionPlenaria
     */
    'solicitudId': number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionPlenaria
     */
    'usuarioId': number;
    /**
     * 
     * @type {number}
     * @memberof EvaluacionPlenaria
     */
    'convocatoriaId': number;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluacionPlenaria
     */
    'activated'?: boolean;
    /**
     * 
     * @type {Solicitud}
     * @memberof EvaluacionPlenaria
     */
    'solicitud'?: Solicitud;
    /**
     * 
     * @type {Usuario}
     * @memberof EvaluacionPlenaria
     */
    'usuario'?: Usuario;
    /**
     * 
     * @type {Convocatoria}
     * @memberof EvaluacionPlenaria
     */
    'convocatoria'?: Convocatoria;
    /**
     * 
     * @type {Array<EstatusEvaluacionPlenaria>}
     * @memberof EvaluacionPlenaria
     */
    'estatusEvaluaciones'?: Array<EstatusEvaluacionPlenaria>;
    /**
     * 
     * @type {DetalleEvaluacionPlenaria}
     * @memberof EvaluacionPlenaria
     */
    'detalleEvaluacion'?: DetalleEvaluacionPlenaria;
}
/**
 * 
 * @export
 * @interface ExistsResponse
 */
export interface ExistsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExistsResponse
     */
    'exists': boolean;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'folio': string;
}
/**
 * 
 * @export
 * @interface Participante
 */
export interface Participante {
    /**
     * 
     * @type {number}
     * @memberof Participante
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'cvu': string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'curp': string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'apellidoPaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'apellidoMaterno'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'genero'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'nivelSni'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'descNivelSni'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'fechaInicio'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'fechaFin'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'tipoVigencia'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'nombreVigencia'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'areaConocimiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'descAreaConocimiento'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Participante
     */
    'vigenciaActiva'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Participante
     */
    'estatusVigencia'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'estatusDescripcion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Participante
     */
    'correo'?: string;
}
/**
 * 
 * @export
 * @interface ParticipantePrevio
 */
export interface ParticipantePrevio {
    /**
     * Indica si el participante está disponible (true) o ya fue ingresado previamente (false)
     * @type {boolean}
     * @memberof ParticipantePrevio
     */
    'disponible': boolean;
    /**
     * Mensaje adicional en caso de que el participante no esté disponible
     * @type {string}
     * @memberof ParticipantePrevio
     */
    'mensaje'?: string;
}
/**
 * 
 * @export
 * @interface Persona
 */
export interface Persona {
    /**
     * 
     * @type {number}
     * @memberof Persona
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Persona
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'curp'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'nivelSnii'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'primerApellido'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'segundoApellido'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'fechaNacimiento'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'generoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'generoNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'nacionalidadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'nacionalidadNombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'paisNacimientoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'paisNacimientoNombre'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Persona
     */
    'activated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Persona
     */
    'correo'?: string;
}
/**
 * 
 * @export
 * @interface PreguntaDetalleEvaluacionIndividual
 */
export interface PreguntaDetalleEvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof PreguntaDetalleEvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PreguntaDetalleEvaluacionIndividual
     */
    'pregunta': string;
    /**
     * 
     * @type {string}
     * @memberof PreguntaDetalleEvaluacionIndividual
     */
    'respuesta'?: string;
    /**
     * 
     * @type {number}
     * @memberof PreguntaDetalleEvaluacionIndividual
     */
    'evaluacion'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PreguntaDetalleEvaluacionIndividual
     */
    'activated': boolean;
    /**
     * 
     * @type {number}
     * @memberof PreguntaDetalleEvaluacionIndividual
     */
    'detalleEvaluacionIndividualId': number;
}
/**
 * 
 * @export
 * @interface Problem
 */
export interface Problem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced, it SHOULD provide human-readable documentation for the problem type (e.g., using HTML). 
     * @type {string}
     * @memberof Problem
     */
    'type'?: string;
    /**
     * A short, summary of the problem type. Written in english and readable for engineers (usually not suited for non technical stakeholders and not localized); example: Service Unavailable 
     * @type {string}
     * @memberof Problem
     */
    'title'?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem. 
     * @type {number}
     * @memberof Problem
     */
    'status'?: number;
    /**
     * A human readable explanation specific to this occurrence of the problem. 
     * @type {string}
     * @memberof Problem
     */
    'detail'?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced. 
     * @type {string}
     * @memberof Problem
     */
    'instance'?: string;
}
/**
 * 
 * @export
 * @interface Proponente
 */
export interface Proponente {
    /**
     * 
     * @type {number}
     * @memberof Proponente
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Proponente
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Proponente
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof Proponente
     */
    'nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof Proponente
     */
    'primerApellido'?: string;
    /**
     * 
     * @type {string}
     * @memberof Proponente
     */
    'segundoApellido'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Proponente
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface Rol
 */
export interface Rol {
    /**
     * 
     * @type {number}
     * @memberof Rol
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Rol
     */
    'rol': string;
    /**
     * 
     * @type {string}
     * @memberof Rol
     */
    'tipo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Rol
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface Solicitud
 */
export interface Solicitud {
    /**
     * 
     * @type {number}
     * @memberof Solicitud
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Solicitud
     */
    'fechaSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof Solicitud
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof Solicitud
     */
    'url'?: string;
    /**
     * 
     * @type {Convocatoria}
     * @memberof Solicitud
     */
    'convocatoria'?: Convocatoria;
    /**
     * 
     * @type {Proponente}
     * @memberof Solicitud
     */
    'proponente'?: Proponente;
    /**
     * 
     * @type {DatosSolicitud}
     * @memberof Solicitud
     */
    'datosSolicitud'?: DatosSolicitud;
    /**
     * 
     * @type {DatosSolicitud2026}
     * @memberof Solicitud
     */
    'datosSolicitud2026'?: DatosSolicitud2026;
    /**
     * 
     * @type {Array<Documento>}
     * @memberof Solicitud
     */
    'documentos'?: Array<Documento>;
    /**
     * 
     * @type {Persona}
     * @memberof Solicitud
     */
    'persona'?: Persona;
    /**
     * 
     * @type {Array<EstatusSolicitud>}
     * @memberof Solicitud
     */
    'estatusSolicitudes'?: Array<EstatusSolicitud>;
    /**
     * 
     * @type {Array<ValidacionDocumental>}
     * @memberof Solicitud
     */
    'validacionDocumental'?: Array<ValidacionDocumental>;
    /**
     * 
     * @type {boolean}
     * @memberof Solicitud
     */
    'activated'?: boolean;
}
/**
 * Resumen ligero de solicitud disponible para asignación. Incluye estatus de la solicitud y de la validación documental. 
 * @export
 * @interface SolicitudLibre
 */
export interface SolicitudLibre {
    /**
     * 
     * @type {number}
     * @memberof SolicitudLibre
     */
    'solicitudId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'fechaSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'url'?: string;
    /**
     * Estatus actual de la solicitud (del catálogo de estatus de solicitud).
     * @type {string}
     * @memberof SolicitudLibre
     */
    'estatusSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'solicitanteCvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'solicitanteCurp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'solicitanteNombreCompleto'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'solicitanteCorreoElectronico'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'nivelSnii'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'proponenteCvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'proponenteNombreCompleto'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'institucion'?: string;
    /**
     * Estatus de la validación documental (puede ser null si no existe). Para este endpoint se consideran válidas las solicitudes con null o ACTIVA. 
     * @type {string}
     * @memberof SolicitudLibre
     */
    'estatusValidacionDocumental'?: string | null;
}
/**
 * 
 * @export
 * @interface SolicitudPostulante
 */
export interface SolicitudPostulante {
    /**
     * 
     * @type {number}
     * @memberof SolicitudPostulante
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'fechaSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'solicitanteCvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'solicitanteCurp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'solicitanteNombreCompleto'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'nivelSnii'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'institucion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'estatusSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'estatusValidacionDocumental'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'validadorNombreCompleto'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SolicitudPostulante
     */
    'comentarioValidacionDocumental'?: string | null;
}
/**
 * 
 * @export
 * @interface SolicitudResumen
 */
export interface SolicitudResumen {
    /**
     * 
     * @type {number}
     * @memberof SolicitudResumen
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumen
     */
    'fechaSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumen
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumen
     */
    'url'?: string;
    /**
     * 
     * @type {SolicitudResumenProponente}
     * @memberof SolicitudResumen
     */
    'proponente'?: SolicitudResumenProponente;
    /**
     * 
     * @type {SolicitudResumenDatosSolicitud}
     * @memberof SolicitudResumen
     */
    'datosSolicitud'?: SolicitudResumenDatosSolicitud;
    /**
     * 
     * @type {Persona}
     * @memberof SolicitudResumen
     */
    'persona'?: Persona;
}
/**
 * 
 * @export
 * @interface SolicitudResumenDatosSolicitud
 */
export interface SolicitudResumenDatosSolicitud {
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumenDatosSolicitud
     */
    'institucion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumenDatosSolicitud
     */
    'semblanza'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumenDatosSolicitud
     */
    'evidenciaImpacto'?: string;
}
/**
 * 
 * @export
 * @interface SolicitudResumenProponente
 */
export interface SolicitudResumenProponente {
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumenProponente
     */
    'cvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof SolicitudResumenProponente
     */
    'nombreCompleto'?: string;
}
/**
 * 
 * @export
 * @interface TermCondEvaluacionIndividual
 */
export interface TermCondEvaluacionIndividual {
    /**
     * 
     * @type {number}
     * @memberof TermCondEvaluacionIndividual
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TermCondEvaluacionIndividual
     */
    'usuarioId': number;
    /**
     * 
     * @type {number}
     * @memberof TermCondEvaluacionIndividual
     */
    'convocatoriaId': number;
    /**
     * 
     * @type {boolean}
     * @memberof TermCondEvaluacionIndividual
     */
    'activated'?: boolean;
    /**
     * 
     * @type {Usuario}
     * @memberof TermCondEvaluacionIndividual
     */
    'usuario'?: Usuario;
    /**
     * 
     * @type {Convocatoria}
     * @memberof TermCondEvaluacionIndividual
     */
    'convocatoria'?: Convocatoria;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TipoArchivo = {
    Pdf: 'PDF',
    Imagen: 'IMAGEN'
} as const;

export type TipoArchivo = typeof TipoArchivo[keyof typeof TipoArchivo];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoCatEstatusSolicitud = {
    Creada: 'CREADA',
    Enviada: 'ENVIADA'
} as const;

export type TipoCatEstatusSolicitud = typeof TipoCatEstatusSolicitud[keyof typeof TipoCatEstatusSolicitud];


/**
 * 
 * @export
 * @enum {string}
 */

export const TipoDocumento = {
    IdentificacionOficial: 'IDENTIFICACION_OFICIAL',
    Curp: 'CURP',
    ActaNacimiento: 'ACTA_NACIMIENTO',
    CartaPostulacion: 'CARTA_POSTULACION',
    CartaAceptacion: 'CARTA_ACEPTACION',
    CartaExposicionMotivos: 'CARTA_EXPOSICION_MOTIVOS',
    CurriculumVitae: 'CURRICULUM_VITAE',
    GradoAcademico: 'GRADO_ACADEMICO',
    Nacionalidad: 'NACIONALIDAD'
} as const;

export type TipoDocumento = typeof TipoDocumento[keyof typeof TipoDocumento];


/**
 * 
 * @export
 * @interface Usuario
 */
export interface Usuario {
    /**
     * 
     * @type {number}
     * @memberof Usuario
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Usuario
     */
    'cvu': string;
    /**
     * 
     * @type {string}
     * @memberof Usuario
     */
    'nombre': string;
    /**
     * 
     * @type {string}
     * @memberof Usuario
     */
    'apellidoPaterno': string;
    /**
     * 
     * @type {string}
     * @memberof Usuario
     */
    'apellidoMaterno': string;
    /**
     * 
     * @type {string}
     * @memberof Usuario
     */
    'curp'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Usuario
     */
    'activated'?: boolean;
    /**
     * 
     * @type {Array<UsuarioRoles>}
     * @memberof Usuario
     */
    'roles'?: Array<UsuarioRoles>;
}
/**
 * 
 * @export
 * @interface UsuarioRol
 */
export interface UsuarioRol {
    /**
     * 
     * @type {number}
     * @memberof UsuarioRol
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsuarioRol
     */
    'idUsuario': number;
    /**
     * 
     * @type {number}
     * @memberof UsuarioRol
     */
    'idRol': number;
    /**
     * 
     * @type {number}
     * @memberof UsuarioRol
     */
    'idConvocatoria'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UsuarioRol
     */
    'activated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UsuarioRol
     */
    'miembroComisionPlenaria'?: boolean;
}
/**
 * 
 * @export
 * @interface UsuarioRoles
 */
export interface UsuarioRoles {
    /**
     * 
     * @type {number}
     * @memberof UsuarioRoles
     */
    'idUsuarioRol'?: number;
    /**
     * 
     * @type {number}
     * @memberof UsuarioRoles
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UsuarioRoles
     */
    'rol'?: string;
    /**
     * 
     * @type {number}
     * @memberof UsuarioRoles
     */
    'idConvocatoria'?: number;
    /**
     * 
     * @type {string}
     * @memberof UsuarioRoles
     */
    'convocatoria'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UsuarioRoles
     */
    'miembroComisionPlenaria'?: boolean;
}
/**
 * 
 * @export
 * @interface ValidacionDocumental
 */
export interface ValidacionDocumental {
    /**
     * 
     * @type {number}
     * @memberof ValidacionDocumental
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidacionDocumental
     */
    'solicitudId': number;
    /**
     * 
     * @type {CatalogoDetalle}
     * @memberof ValidacionDocumental
     */
    'estatusValidacionDocumental'?: CatalogoDetalle;
    /**
     * 
     * @type {string}
     * @memberof ValidacionDocumental
     */
    'comentario'?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionDocumental
     */
    'cvuValidadorDocumental': string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionDocumental
     */
    'nombreValidadorDocumental': string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionDocumental
     */
    'primerApellidoValidadorDocumental': string;
    /**
     * 
     * @type {string}
     * @memberof ValidacionDocumental
     */
    'segundoApellidoValidadorDocumental'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidacionDocumental
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface VwResumenEvaluadoresIndividuales
 */
export interface VwResumenEvaluadoresIndividuales {
    /**
     * 
     * @type {number}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'idEvaluacionIndividual'?: number;
    /**
     * 
     * @type {number}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'convocatoriaId'?: number;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'anioConvocatoria'?: string;
    /**
     * 
     * @type {number}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'idSolicitud'?: number;
    /**
     * 
     * @type {number}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'idUsuario'?: number;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'evaluadorCvu'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'folio'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'cvuPostulante'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'postulante'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'cvuPostulador'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'postulador'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'estatusSolicitud'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'estatusEvaluacion'?: string;
    /**
     * 
     * @type {string}
     * @memberof VwResumenEvaluadoresIndividuales
     */
    'resultadoEvaluacion'?: string;
}

/**
 * AsignacionEvaluadoresApi - axios parameter creator
 * @export
 */
export const AsignacionEvaluadoresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Listado de evaluadores por convocatoria (incluye usuarios sin solicitudes asignadas)
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsignacionEvaluadoresByConvocatoria: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAsignacionEvaluadoresByConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/asignacion-evaluadores/convocatoria/{idConvocatoria}`
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Listado de solicitudes no asignadas a evaluadores en la convocatoria
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitudesLibresByConvocatoria: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getSolicitudesLibresByConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/asignacion-evaluadores/convocatoria/{idConvocatoria}/solicitudes-libres`
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AsignacionEvaluadoresApi - functional programming interface
 * @export
 */
export const AsignacionEvaluadoresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AsignacionEvaluadoresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Listado de evaluadores por convocatoria (incluye usuarios sin solicitudes asignadas)
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsignacionEvaluadoresByConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AsignacionEvaluadorResumen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsignacionEvaluadoresByConvocatoria(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Listado de solicitudes no asignadas a evaluadores en la convocatoria
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolicitudesLibresByConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SolicitudLibre>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSolicitudesLibresByConvocatoria(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AsignacionEvaluadoresApi - factory interface
 * @export
 */
export const AsignacionEvaluadoresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AsignacionEvaluadoresApiFp(configuration)
    return {
        /**
         * 
         * @summary Listado de evaluadores por convocatoria (incluye usuarios sin solicitudes asignadas)
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsignacionEvaluadoresByConvocatoria(idConvocatoria: number, options?: any): AxiosPromise<Array<AsignacionEvaluadorResumen>> {
            return localVarFp.getAsignacionEvaluadoresByConvocatoria(idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado de solicitudes no asignadas a evaluadores en la convocatoria
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitudesLibresByConvocatoria(idConvocatoria: number, options?: any): AxiosPromise<Array<SolicitudLibre>> {
            return localVarFp.getSolicitudesLibresByConvocatoria(idConvocatoria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AsignacionEvaluadoresApi - object-oriented interface
 * @export
 * @class AsignacionEvaluadoresApi
 * @extends {BaseAPI}
 */
export class AsignacionEvaluadoresApi extends BaseAPI {
    /**
     * 
     * @summary Listado de evaluadores por convocatoria (incluye usuarios sin solicitudes asignadas)
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsignacionEvaluadoresApi
     */
    public getAsignacionEvaluadoresByConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig) {
        return AsignacionEvaluadoresApiFp(this.configuration).getAsignacionEvaluadoresByConvocatoria(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado de solicitudes no asignadas a evaluadores en la convocatoria
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsignacionEvaluadoresApi
     */
    public getSolicitudesLibresByConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig) {
        return AsignacionEvaluadoresApiFp(this.configuration).getSolicitudesLibresByConvocatoria(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BitacoraRechazoEvaluacionIndividualApi - axios parameter creator
 * @export
 */
export const BitacoraRechazoEvaluacionIndividualApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtener bitácora de rechazos por evaluación individual
         * @param {number} idEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBitacoraRechazoByIdEvaluacionIndividual: async (idEvaluacionIndividual: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idEvaluacionIndividual' is not null or undefined
            assertParamExists('getBitacoraRechazoByIdEvaluacionIndividual', 'idEvaluacionIndividual', idEvaluacionIndividual)
            const localVarPath = `/bitacora-rechazo-evaluacion-individual/{idEvaluacionIndividual}`
                .replace(`{${"idEvaluacionIndividual"}}`, encodeURIComponent(String(idEvaluacionIndividual)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BitacoraRechazoEvaluacionIndividualApi - functional programming interface
 * @export
 */
export const BitacoraRechazoEvaluacionIndividualApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BitacoraRechazoEvaluacionIndividualApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtener bitácora de rechazos por evaluación individual
         * @param {number} idEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBitacoraRechazoByIdEvaluacionIndividual(idEvaluacionIndividual: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BitacoraRechazoEvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBitacoraRechazoByIdEvaluacionIndividual(idEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BitacoraRechazoEvaluacionIndividualApi - factory interface
 * @export
 */
export const BitacoraRechazoEvaluacionIndividualApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BitacoraRechazoEvaluacionIndividualApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtener bitácora de rechazos por evaluación individual
         * @param {number} idEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBitacoraRechazoByIdEvaluacionIndividual(idEvaluacionIndividual: number, options?: any): AxiosPromise<BitacoraRechazoEvaluacionIndividual> {
            return localVarFp.getBitacoraRechazoByIdEvaluacionIndividual(idEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BitacoraRechazoEvaluacionIndividualApi - object-oriented interface
 * @export
 * @class BitacoraRechazoEvaluacionIndividualApi
 * @extends {BaseAPI}
 */
export class BitacoraRechazoEvaluacionIndividualApi extends BaseAPI {
    /**
     * 
     * @summary Obtener bitácora de rechazos por evaluación individual
     * @param {number} idEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BitacoraRechazoEvaluacionIndividualApi
     */
    public getBitacoraRechazoByIdEvaluacionIndividual(idEvaluacionIndividual: number, options?: AxiosRequestConfig) {
        return BitacoraRechazoEvaluacionIndividualApiFp(this.configuration).getBitacoraRechazoByIdEvaluacionIndividual(idEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CatalogoDetalleApi - axios parameter creator
 * @export
 */
export const CatalogoDetalleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtener detalles de catálogo por clave de maestro
         * @param {string} clave Clave del catálogo maestro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoDetalleByClave: async (clave: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clave' is not null or undefined
            assertParamExists('getCatalogoDetalleByClave', 'clave', clave)
            const localVarPath = `/catalogo-detalle/{clave}`
                .replace(`{${"clave"}}`, encodeURIComponent(String(clave)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener detalles de catálogo por clave de maestro
         * @param {string} claveMaestro Clave del catálogo maestro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoDetalleByClaveMaestro: async (claveMaestro: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claveMaestro' is not null or undefined
            assertParamExists('getCatalogoDetalleByClaveMaestro', 'claveMaestro', claveMaestro)
            const localVarPath = `/catalogo-detalle/maestro/{claveMaestro}`
                .replace(`{${"claveMaestro"}}`, encodeURIComponent(String(claveMaestro)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogoDetalleApi - functional programming interface
 * @export
 */
export const CatalogoDetalleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogoDetalleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtener detalles de catálogo por clave de maestro
         * @param {string} clave Clave del catálogo maestro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogoDetalleByClave(clave: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogoDetalle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogoDetalleByClave(clave, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener detalles de catálogo por clave de maestro
         * @param {string} claveMaestro Clave del catálogo maestro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogoDetalleByClaveMaestro(claveMaestro: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogoDetalle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogoDetalleByClaveMaestro(claveMaestro, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CatalogoDetalleApi - factory interface
 * @export
 */
export const CatalogoDetalleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogoDetalleApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtener detalles de catálogo por clave de maestro
         * @param {string} clave Clave del catálogo maestro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoDetalleByClave(clave: string, options?: any): AxiosPromise<Array<CatalogoDetalle>> {
            return localVarFp.getCatalogoDetalleByClave(clave, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener detalles de catálogo por clave de maestro
         * @param {string} claveMaestro Clave del catálogo maestro
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogoDetalleByClaveMaestro(claveMaestro: string, options?: any): AxiosPromise<Array<CatalogoDetalle>> {
            return localVarFp.getCatalogoDetalleByClaveMaestro(claveMaestro, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogoDetalleApi - object-oriented interface
 * @export
 * @class CatalogoDetalleApi
 * @extends {BaseAPI}
 */
export class CatalogoDetalleApi extends BaseAPI {
    /**
     * 
     * @summary Obtener detalles de catálogo por clave de maestro
     * @param {string} clave Clave del catálogo maestro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogoDetalleApi
     */
    public getCatalogoDetalleByClave(clave: string, options?: AxiosRequestConfig) {
        return CatalogoDetalleApiFp(this.configuration).getCatalogoDetalleByClave(clave, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener detalles de catálogo por clave de maestro
     * @param {string} claveMaestro Clave del catálogo maestro
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogoDetalleApi
     */
    public getCatalogoDetalleByClaveMaestro(claveMaestro: string, options?: AxiosRequestConfig) {
        return CatalogoDetalleApiFp(this.configuration).getCatalogoDetalleByClaveMaestro(claveMaestro, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConstanciasApi - axios parameter creator
 * @export
 */
export const ConstanciasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Listado de usuarios con constancias en base a la vista vw_constancias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstancias: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/constancias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Constancias del usuario autenticado para una convocatoria
         * @param {number} idConvocatoria ID de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstanciasPorConvocatoria: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getConstanciasPorConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/constancias/{idConvocatoria}`
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener reporte de las constancias
         * @param {number} idConvocatoria ID de la convocatoria para filtrar el reporte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReporteConstancias: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getReporteConstancias', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/constancias/reporte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idConvocatoria !== undefined) {
                localVarQueryParameter['idConvocatoria'] = idConvocatoria;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del evaluador individual
         * @param {string} cvu CVU del usuario
         * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlConstanciaEvaluadorIndividual: async (cvu: string, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            assertParamExists('getUrlConstanciaEvaluadorIndividual', 'cvu', cvu)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getUrlConstanciaEvaluadorIndividual', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/constancias/evaluador-individual/{cvu}/pdf`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idConvocatoria !== undefined) {
                localVarQueryParameter['idConvocatoria'] = idConvocatoria;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del miembro de comisión
         * @param {string} cvu CVU del usuario
         * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlConstanciaMiembroComision: async (cvu: string, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            assertParamExists('getUrlConstanciaMiembroComision', 'cvu', cvu)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getUrlConstanciaMiembroComision', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/constancias/miembro-comision/{cvu}/pdf`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idConvocatoria !== undefined) {
                localVarQueryParameter['idConvocatoria'] = idConvocatoria;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConstanciasApi - functional programming interface
 * @export
 */
export const ConstanciasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConstanciasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Listado de usuarios con constancias en base a la vista vw_constancias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConstancias(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Constancia>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConstancias(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Constancias del usuario autenticado para una convocatoria
         * @param {number} idConvocatoria ID de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConstanciasPorConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Constancia>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConstanciasPorConvocatoria(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener reporte de las constancias
         * @param {number} idConvocatoria ID de la convocatoria para filtrar el reporte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReporteConstancias(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReporteConstancias(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del evaluador individual
         * @param {string} cvu CVU del usuario
         * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUrlConstanciaEvaluadorIndividual(cvu: string, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUrlConstanciaEvaluadorIndividual(cvu, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del miembro de comisión
         * @param {string} cvu CVU del usuario
         * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUrlConstanciaMiembroComision(cvu: string, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUrlConstanciaMiembroComision(cvu, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConstanciasApi - factory interface
 * @export
 */
export const ConstanciasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConstanciasApiFp(configuration)
    return {
        /**
         * 
         * @summary Listado de usuarios con constancias en base a la vista vw_constancias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstancias(options?: any): AxiosPromise<Array<Constancia>> {
            return localVarFp.getConstancias(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Constancias del usuario autenticado para una convocatoria
         * @param {number} idConvocatoria ID de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstanciasPorConvocatoria(idConvocatoria: number, options?: any): AxiosPromise<Array<Constancia>> {
            return localVarFp.getConstanciasPorConvocatoria(idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener reporte de las constancias
         * @param {number} idConvocatoria ID de la convocatoria para filtrar el reporte
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReporteConstancias(idConvocatoria: number, options?: any): AxiosPromise<any> {
            return localVarFp.getReporteConstancias(idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del evaluador individual
         * @param {string} cvu CVU del usuario
         * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlConstanciaEvaluadorIndividual(cvu: string, idConvocatoria: number, options?: any): AxiosPromise<string> {
            return localVarFp.getUrlConstanciaEvaluadorIndividual(cvu, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del miembro de comisión
         * @param {string} cvu CVU del usuario
         * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrlConstanciaMiembroComision(cvu: string, idConvocatoria: number, options?: any): AxiosPromise<string> {
            return localVarFp.getUrlConstanciaMiembroComision(cvu, idConvocatoria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConstanciasApi - object-oriented interface
 * @export
 * @class ConstanciasApi
 * @extends {BaseAPI}
 */
export class ConstanciasApi extends BaseAPI {
    /**
     * 
     * @summary Listado de usuarios con constancias en base a la vista vw_constancias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstanciasApi
     */
    public getConstancias(options?: AxiosRequestConfig) {
        return ConstanciasApiFp(this.configuration).getConstancias(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Constancias del usuario autenticado para una convocatoria
     * @param {number} idConvocatoria ID de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstanciasApi
     */
    public getConstanciasPorConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig) {
        return ConstanciasApiFp(this.configuration).getConstanciasPorConvocatoria(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener reporte de las constancias
     * @param {number} idConvocatoria ID de la convocatoria para filtrar el reporte
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstanciasApi
     */
    public getReporteConstancias(idConvocatoria: number, options?: AxiosRequestConfig) {
        return ConstanciasApiFp(this.configuration).getReporteConstancias(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del evaluador individual
     * @param {string} cvu CVU del usuario
     * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstanciasApi
     */
    public getUrlConstanciaEvaluadorIndividual(cvu: string, idConvocatoria: number, options?: AxiosRequestConfig) {
        return ConstanciasApiFp(this.configuration).getUrlConstanciaEvaluadorIndividual(cvu, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generar PDF y carga en DMS de constancia de evaluación por CVU del miembro de comisión
     * @param {string} cvu CVU del usuario
     * @param {number} idConvocatoria ID de la convocatoria para la que se genera la constancia
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConstanciasApi
     */
    public getUrlConstanciaMiembroComision(cvu: string, idConvocatoria: number, options?: AxiosRequestConfig) {
        return ConstanciasApiFp(this.configuration).getUrlConstanciaMiembroComision(cvu, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConvocatoriasApi - axios parameter creator
 * @export
 */
export const ConvocatoriasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtener todas las convocatorias registradas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConvocatorias: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/convocatorias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validar si la convocatoria está en periodo activo
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarPeriodoConvocatoria: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validarPeriodoConvocatoria', 'id', id)
            const localVarPath = `/convocatorias/{id}/validar-periodo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConvocatoriasApi - functional programming interface
 * @export
 */
export const ConvocatoriasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConvocatoriasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtener todas las convocatorias registradas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllConvocatorias(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Convocatoria>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllConvocatorias(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validar si la convocatoria está en periodo activo
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validarPeriodoConvocatoria(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validarPeriodoConvocatoria(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConvocatoriasApi - factory interface
 * @export
 */
export const ConvocatoriasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConvocatoriasApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtener todas las convocatorias registradas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConvocatorias(options?: any): AxiosPromise<Array<Convocatoria>> {
            return localVarFp.getAllConvocatorias(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validar si la convocatoria está en periodo activo
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validarPeriodoConvocatoria(id: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.validarPeriodoConvocatoria(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConvocatoriasApi - object-oriented interface
 * @export
 * @class ConvocatoriasApi
 * @extends {BaseAPI}
 */
export class ConvocatoriasApi extends BaseAPI {
    /**
     * 
     * @summary Obtener todas las convocatorias registradas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriasApi
     */
    public getAllConvocatorias(options?: AxiosRequestConfig) {
        return ConvocatoriasApiFp(this.configuration).getAllConvocatorias(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validar si la convocatoria está en periodo activo
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvocatoriasApi
     */
    public validarPeriodoConvocatoria(id: number, options?: AxiosRequestConfig) {
        return ConvocatoriasApiFp(this.configuration).validarPeriodoConvocatoria(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DatosSolicitudApi - axios parameter creator
 * @export
 */
export const DatosSolicitudApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva datos-solicitud
         * @param {DatosSolicitud} datosSolicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatosSolicitud: async (datosSolicitud: DatosSolicitud, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datosSolicitud' is not null or undefined
            assertParamExists('createDatosSolicitud', 'datosSolicitud', datosSolicitud)
            const localVarPath = `/datos-solicitud`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datosSolicitud, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar datos-solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatosSolicitud: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDatosSolicitud', 'id', id)
            const localVarPath = `/datos-solicitud/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener datos-solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosSolicitud: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatosSolicitud', 'id', id)
            const localVarPath = `/datos-solicitud/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar datos-solicitud existente por ID
         * @param {number} id Identificador único
         * @param {DatosSolicitud} datosSolicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatosSolicitud: async (id: number, datosSolicitud: DatosSolicitud, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDatosSolicitud', 'id', id)
            // verify required parameter 'datosSolicitud' is not null or undefined
            assertParamExists('updateDatosSolicitud', 'datosSolicitud', datosSolicitud)
            const localVarPath = `/datos-solicitud/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datosSolicitud, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatosSolicitudApi - functional programming interface
 * @export
 */
export const DatosSolicitudApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatosSolicitudApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva datos-solicitud
         * @param {DatosSolicitud} datosSolicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatosSolicitud(datosSolicitud: DatosSolicitud, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSolicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatosSolicitud(datosSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar datos-solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDatosSolicitud(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDatosSolicitud(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener datos-solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosSolicitud(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSolicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosSolicitud(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar datos-solicitud existente por ID
         * @param {number} id Identificador único
         * @param {DatosSolicitud} datosSolicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatosSolicitud(id: number, datosSolicitud: DatosSolicitud, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSolicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatosSolicitud(id, datosSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatosSolicitudApi - factory interface
 * @export
 */
export const DatosSolicitudApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatosSolicitudApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva datos-solicitud
         * @param {DatosSolicitud} datosSolicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatosSolicitud(datosSolicitud: DatosSolicitud, options?: any): AxiosPromise<DatosSolicitud> {
            return localVarFp.createDatosSolicitud(datosSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar datos-solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatosSolicitud(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDatosSolicitud(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener datos-solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosSolicitud(id: number, options?: any): AxiosPromise<DatosSolicitud> {
            return localVarFp.getDatosSolicitud(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar datos-solicitud existente por ID
         * @param {number} id Identificador único
         * @param {DatosSolicitud} datosSolicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatosSolicitud(id: number, datosSolicitud: DatosSolicitud, options?: any): AxiosPromise<DatosSolicitud> {
            return localVarFp.updateDatosSolicitud(id, datosSolicitud, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatosSolicitudApi - object-oriented interface
 * @export
 * @class DatosSolicitudApi
 * @extends {BaseAPI}
 */
export class DatosSolicitudApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva datos-solicitud
     * @param {DatosSolicitud} datosSolicitud 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitudApi
     */
    public createDatosSolicitud(datosSolicitud: DatosSolicitud, options?: AxiosRequestConfig) {
        return DatosSolicitudApiFp(this.configuration).createDatosSolicitud(datosSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar datos-solicitud por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitudApi
     */
    public deleteDatosSolicitud(id: number, options?: AxiosRequestConfig) {
        return DatosSolicitudApiFp(this.configuration).deleteDatosSolicitud(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener datos-solicitud por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitudApi
     */
    public getDatosSolicitud(id: number, options?: AxiosRequestConfig) {
        return DatosSolicitudApiFp(this.configuration).getDatosSolicitud(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar datos-solicitud existente por ID
     * @param {number} id Identificador único
     * @param {DatosSolicitud} datosSolicitud 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitudApi
     */
    public updateDatosSolicitud(id: number, datosSolicitud: DatosSolicitud, options?: AxiosRequestConfig) {
        return DatosSolicitudApiFp(this.configuration).updateDatosSolicitud(id, datosSolicitud, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DatosSolicitud2026Api - axios parameter creator
 * @export
 */
export const DatosSolicitud2026ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear datos de solicitud 2026
         * @param {DatosSolicitud2026} datosSolicitud2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatosSolicitud2026: async (datosSolicitud2026: DatosSolicitud2026, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datosSolicitud2026' is not null or undefined
            assertParamExists('createDatosSolicitud2026', 'datosSolicitud2026', datosSolicitud2026)
            const localVarPath = `/datos-solicitud-2026`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datosSolicitud2026, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatosSolicitud2026: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDatosSolicitud2026', 'id', id)
            const localVarPath = `/datos-solicitud-2026/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosSolicitud2026: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDatosSolicitud2026', 'id', id)
            const localVarPath = `/datos-solicitud-2026/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {DatosSolicitud2026} datosSolicitud2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatosSolicitud2026: async (id: number, datosSolicitud2026: DatosSolicitud2026, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDatosSolicitud2026', 'id', id)
            // verify required parameter 'datosSolicitud2026' is not null or undefined
            assertParamExists('updateDatosSolicitud2026', 'datosSolicitud2026', datosSolicitud2026)
            const localVarPath = `/datos-solicitud-2026/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datosSolicitud2026, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatosSolicitud2026Api - functional programming interface
 * @export
 */
export const DatosSolicitud2026ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatosSolicitud2026ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear datos de solicitud 2026
         * @param {DatosSolicitud2026} datosSolicitud2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatosSolicitud2026(datosSolicitud2026: DatosSolicitud2026, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSolicitud2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatosSolicitud2026(datosSolicitud2026, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDatosSolicitud2026(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDatosSolicitud2026(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatosSolicitud2026(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSolicitud2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatosSolicitud2026(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {DatosSolicitud2026} datosSolicitud2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDatosSolicitud2026(id: number, datosSolicitud2026: DatosSolicitud2026, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatosSolicitud2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDatosSolicitud2026(id, datosSolicitud2026, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatosSolicitud2026Api - factory interface
 * @export
 */
export const DatosSolicitud2026ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatosSolicitud2026ApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear datos de solicitud 2026
         * @param {DatosSolicitud2026} datosSolicitud2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatosSolicitud2026(datosSolicitud2026: DatosSolicitud2026, options?: any): AxiosPromise<DatosSolicitud2026> {
            return localVarFp.createDatosSolicitud2026(datosSolicitud2026, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatosSolicitud2026(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDatosSolicitud2026(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatosSolicitud2026(id: number, options?: any): AxiosPromise<DatosSolicitud2026> {
            return localVarFp.getDatosSolicitud2026(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar datos de solicitud 2026 por ID
         * @param {number} id Identificador único
         * @param {DatosSolicitud2026} datosSolicitud2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDatosSolicitud2026(id: number, datosSolicitud2026: DatosSolicitud2026, options?: any): AxiosPromise<DatosSolicitud2026> {
            return localVarFp.updateDatosSolicitud2026(id, datosSolicitud2026, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatosSolicitud2026Api - object-oriented interface
 * @export
 * @class DatosSolicitud2026Api
 * @extends {BaseAPI}
 */
export class DatosSolicitud2026Api extends BaseAPI {
    /**
     * 
     * @summary Crear datos de solicitud 2026
     * @param {DatosSolicitud2026} datosSolicitud2026 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitud2026Api
     */
    public createDatosSolicitud2026(datosSolicitud2026: DatosSolicitud2026, options?: AxiosRequestConfig) {
        return DatosSolicitud2026ApiFp(this.configuration).createDatosSolicitud2026(datosSolicitud2026, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar datos de solicitud 2026 por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitud2026Api
     */
    public deleteDatosSolicitud2026(id: number, options?: AxiosRequestConfig) {
        return DatosSolicitud2026ApiFp(this.configuration).deleteDatosSolicitud2026(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener datos de solicitud 2026 por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitud2026Api
     */
    public getDatosSolicitud2026(id: number, options?: AxiosRequestConfig) {
        return DatosSolicitud2026ApiFp(this.configuration).getDatosSolicitud2026(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar datos de solicitud 2026 por ID
     * @param {number} id Identificador único
     * @param {DatosSolicitud2026} datosSolicitud2026 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatosSolicitud2026Api
     */
    public updateDatosSolicitud2026(id: number, datosSolicitud2026: DatosSolicitud2026, options?: AxiosRequestConfig) {
        return DatosSolicitud2026ApiFp(this.configuration).updateDatosSolicitud2026(id, datosSolicitud2026, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DetalleEvaluacionIndividualApi - axios parameter creator
 * @export
 */
export const DetalleEvaluacionIndividualApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación individual
         * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetalleEvaluacionIndividual: async (detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detalleEvaluacionIndividual' is not null or undefined
            assertParamExists('createDetalleEvaluacionIndividual', 'detalleEvaluacionIndividual', detalleEvaluacionIndividual)
            const localVarPath = `/detalle-evaluacion-individual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detalleEvaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación individual 2026
         * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetalleEvaluacionIndividual2026: async (detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detalleEvaluacionIndividual2026' is not null or undefined
            assertParamExists('createDetalleEvaluacionIndividual2026', 'detalleEvaluacionIndividual2026', detalleEvaluacionIndividual2026)
            const localVarPath = `/detalle-evaluacion-individual-2026`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detalleEvaluacionIndividual2026, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionIndividual: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetalleEvaluacionIndividual', 'id', id)
            const localVarPath = `/detalle-evaluacion-individual/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionIndividual2026: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetalleEvaluacionIndividual2026', 'id', id)
            const localVarPath = `/detalle-evaluacion-individual-2026/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual 2026 por ID de evaluación
         * @param {number} idEvaluacionIndividual ID de la evaluación individual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId: async (idEvaluacionIndividual: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idEvaluacionIndividual' is not null or undefined
            assertParamExists('getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId', 'idEvaluacionIndividual', idEvaluacionIndividual)
            const localVarPath = `/detalle-evaluacion-individual-2026/evaluacion-individual/{idEvaluacionIndividual}`
                .replace(`{${"idEvaluacionIndividual"}}`, encodeURIComponent(String(idEvaluacionIndividual)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación individual existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetalleEvaluacionIndividual: async (id: number, detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDetalleEvaluacionIndividual', 'id', id)
            // verify required parameter 'detalleEvaluacionIndividual' is not null or undefined
            assertParamExists('updateDetalleEvaluacionIndividual', 'detalleEvaluacionIndividual', detalleEvaluacionIndividual)
            const localVarPath = `/detalle-evaluacion-individual/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detalleEvaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación individual 2026 existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetalleEvaluacionIndividual2026: async (id: number, detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDetalleEvaluacionIndividual2026', 'id', id)
            // verify required parameter 'detalleEvaluacionIndividual2026' is not null or undefined
            assertParamExists('updateDetalleEvaluacionIndividual2026', 'detalleEvaluacionIndividual2026', detalleEvaluacionIndividual2026)
            const localVarPath = `/detalle-evaluacion-individual-2026/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detalleEvaluacionIndividual2026, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetalleEvaluacionIndividualApi - functional programming interface
 * @export
 */
export const DetalleEvaluacionIndividualApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DetalleEvaluacionIndividualApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación individual
         * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDetalleEvaluacionIndividual(detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDetalleEvaluacionIndividual(detalleEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación individual 2026
         * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDetalleEvaluacionIndividual2026(detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDetalleEvaluacionIndividual2026(detalleEvaluacionIndividual2026, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleEvaluacionIndividual(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleEvaluacionIndividual(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleEvaluacionIndividual2026(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleEvaluacionIndividual2026(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual 2026 por ID de evaluación
         * @param {number} idEvaluacionIndividual ID de la evaluación individual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId(idEvaluacionIndividual: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId(idEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación individual existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDetalleEvaluacionIndividual(id: number, detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDetalleEvaluacionIndividual(id, detalleEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación individual 2026 existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDetalleEvaluacionIndividual2026(id: number, detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionIndividual2026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDetalleEvaluacionIndividual2026(id, detalleEvaluacionIndividual2026, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DetalleEvaluacionIndividualApi - factory interface
 * @export
 */
export const DetalleEvaluacionIndividualApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DetalleEvaluacionIndividualApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación individual
         * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetalleEvaluacionIndividual(detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options?: any): AxiosPromise<DetalleEvaluacionIndividual> {
            return localVarFp.createDetalleEvaluacionIndividual(detalleEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación individual 2026
         * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetalleEvaluacionIndividual2026(detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options?: any): AxiosPromise<DetalleEvaluacionIndividual2026> {
            return localVarFp.createDetalleEvaluacionIndividual2026(detalleEvaluacionIndividual2026, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionIndividual(id: number, options?: any): AxiosPromise<DetalleEvaluacionIndividual> {
            return localVarFp.getDetalleEvaluacionIndividual(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual 2026 por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionIndividual2026(id: number, options?: any): AxiosPromise<DetalleEvaluacionIndividual2026> {
            return localVarFp.getDetalleEvaluacionIndividual2026(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener detalle de evaluación individual 2026 por ID de evaluación
         * @param {number} idEvaluacionIndividual ID de la evaluación individual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId(idEvaluacionIndividual: number, options?: any): AxiosPromise<DetalleEvaluacionIndividual2026> {
            return localVarFp.getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId(idEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación individual existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetalleEvaluacionIndividual(id: number, detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options?: any): AxiosPromise<DetalleEvaluacionIndividual> {
            return localVarFp.updateDetalleEvaluacionIndividual(id, detalleEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación individual 2026 existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetalleEvaluacionIndividual2026(id: number, detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options?: any): AxiosPromise<DetalleEvaluacionIndividual2026> {
            return localVarFp.updateDetalleEvaluacionIndividual2026(id, detalleEvaluacionIndividual2026, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DetalleEvaluacionIndividualApi - object-oriented interface
 * @export
 * @class DetalleEvaluacionIndividualApi
 * @extends {BaseAPI}
 */
export class DetalleEvaluacionIndividualApi extends BaseAPI {
    /**
     * 
     * @summary Crear un nuevo detalle de evaluación individual
     * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public createDetalleEvaluacionIndividual(detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).createDetalleEvaluacionIndividual(detalleEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crear un nuevo detalle de evaluación individual 2026
     * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public createDetalleEvaluacionIndividual2026(detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).createDetalleEvaluacionIndividual2026(detalleEvaluacionIndividual2026, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener detalle de evaluación individual por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public getDetalleEvaluacionIndividual(id: number, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).getDetalleEvaluacionIndividual(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener detalle de evaluación individual 2026 por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public getDetalleEvaluacionIndividual2026(id: number, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).getDetalleEvaluacionIndividual2026(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener detalle de evaluación individual 2026 por ID de evaluación
     * @param {number} idEvaluacionIndividual ID de la evaluación individual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId(idEvaluacionIndividual: number, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).getDetalleEvaluacionIndividual2026ByEvaluacionIndividualId(idEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar detalle de evaluación individual existente por ID
     * @param {number} id Identificador único
     * @param {DetalleEvaluacionIndividual} detalleEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public updateDetalleEvaluacionIndividual(id: number, detalleEvaluacionIndividual: DetalleEvaluacionIndividual, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).updateDetalleEvaluacionIndividual(id, detalleEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar detalle de evaluación individual 2026 existente por ID
     * @param {number} id Identificador único
     * @param {DetalleEvaluacionIndividual2026} detalleEvaluacionIndividual2026 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionIndividualApi
     */
    public updateDetalleEvaluacionIndividual2026(id: number, detalleEvaluacionIndividual2026: DetalleEvaluacionIndividual2026, options?: AxiosRequestConfig) {
        return DetalleEvaluacionIndividualApiFp(this.configuration).updateDetalleEvaluacionIndividual2026(id, detalleEvaluacionIndividual2026, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DetalleEvaluacionPlenariaApi - axios parameter creator
 * @export
 */
export const DetalleEvaluacionPlenariaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación plenaria
         * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetalleEvaluacionPlenaria: async (detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detalleEvaluacionPlenaria' is not null or undefined
            assertParamExists('createDetalleEvaluacionPlenaria', 'detalleEvaluacionPlenaria', detalleEvaluacionPlenaria)
            const localVarPath = `/detalle-evaluacion-plenaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detalleEvaluacionPlenaria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener detalle de evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionPlenaria: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetalleEvaluacionPlenaria', 'id', id)
            const localVarPath = `/detalle-evaluacion-plenaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación plenaria existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetalleEvaluacionPlenaria: async (id: number, detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDetalleEvaluacionPlenaria', 'id', id)
            // verify required parameter 'detalleEvaluacionPlenaria' is not null or undefined
            assertParamExists('updateDetalleEvaluacionPlenaria', 'detalleEvaluacionPlenaria', detalleEvaluacionPlenaria)
            const localVarPath = `/detalle-evaluacion-plenaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detalleEvaluacionPlenaria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetalleEvaluacionPlenariaApi - functional programming interface
 * @export
 */
export const DetalleEvaluacionPlenariaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DetalleEvaluacionPlenariaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación plenaria
         * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDetalleEvaluacionPlenaria(detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDetalleEvaluacionPlenaria(detalleEvaluacionPlenaria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener detalle de evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetalleEvaluacionPlenaria(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetalleEvaluacionPlenaria(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación plenaria existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDetalleEvaluacionPlenaria(id: number, detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetalleEvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDetalleEvaluacionPlenaria(id, detalleEvaluacionPlenaria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DetalleEvaluacionPlenariaApi - factory interface
 * @export
 */
export const DetalleEvaluacionPlenariaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DetalleEvaluacionPlenariaApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo detalle de evaluación plenaria
         * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetalleEvaluacionPlenaria(detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options?: any): AxiosPromise<DetalleEvaluacionPlenaria> {
            return localVarFp.createDetalleEvaluacionPlenaria(detalleEvaluacionPlenaria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener detalle de evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetalleEvaluacionPlenaria(id: number, options?: any): AxiosPromise<DetalleEvaluacionPlenaria> {
            return localVarFp.getDetalleEvaluacionPlenaria(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar detalle de evaluación plenaria existente por ID
         * @param {number} id Identificador único
         * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetalleEvaluacionPlenaria(id: number, detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options?: any): AxiosPromise<DetalleEvaluacionPlenaria> {
            return localVarFp.updateDetalleEvaluacionPlenaria(id, detalleEvaluacionPlenaria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DetalleEvaluacionPlenariaApi - object-oriented interface
 * @export
 * @class DetalleEvaluacionPlenariaApi
 * @extends {BaseAPI}
 */
export class DetalleEvaluacionPlenariaApi extends BaseAPI {
    /**
     * 
     * @summary Crear un nuevo detalle de evaluación plenaria
     * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionPlenariaApi
     */
    public createDetalleEvaluacionPlenaria(detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options?: AxiosRequestConfig) {
        return DetalleEvaluacionPlenariaApiFp(this.configuration).createDetalleEvaluacionPlenaria(detalleEvaluacionPlenaria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener detalle de evaluación plenaria por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionPlenariaApi
     */
    public getDetalleEvaluacionPlenaria(id: number, options?: AxiosRequestConfig) {
        return DetalleEvaluacionPlenariaApiFp(this.configuration).getDetalleEvaluacionPlenaria(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar detalle de evaluación plenaria existente por ID
     * @param {number} id Identificador único
     * @param {DetalleEvaluacionPlenaria} detalleEvaluacionPlenaria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetalleEvaluacionPlenariaApi
     */
    public updateDetalleEvaluacionPlenaria(id: number, detalleEvaluacionPlenaria: DetalleEvaluacionPlenaria, options?: AxiosRequestConfig) {
        return DetalleEvaluacionPlenariaApiFp(this.configuration).updateDetalleEvaluacionPlenaria(id, detalleEvaluacionPlenaria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentosApi - axios parameter creator
 * @export
 */
export const DocumentosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear un nuevo documento
         * @param {Documento} documento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumento: async (documento: Documento, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documento' is not null or undefined
            assertParamExists('createDocumento', 'documento', documento)
            const localVarPath = `/documentos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar documento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumento: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumento', 'id', id)
            const localVarPath = `/documentos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todos los documentos por ID de la solicitud
         * @param {number} idSolicitudQuery Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentos: async (idSolicitudQuery: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitudQuery' is not null or undefined
            assertParamExists('getAllDocumentos', 'idSolicitudQuery', idSolicitudQuery)
            const localVarPath = `/documentos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idSolicitudQuery !== undefined) {
                localVarQueryParameter['idSolicitudQuery'] = idSolicitudQuery;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener documento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumento: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocumento', 'id', id)
            const localVarPath = `/documentos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar documento existente por ID
         * @param {number} id Identificador único
         * @param {Documento} documento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumento: async (id: number, documento: Documento, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDocumento', 'id', id)
            // verify required parameter 'documento' is not null or undefined
            assertParamExists('updateDocumento', 'documento', documento)
            const localVarPath = `/documentos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documento, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentosApi - functional programming interface
 * @export
 */
export const DocumentosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo documento
         * @param {Documento} documento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumento(documento: Documento, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Documento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumento(documento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar documento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumento(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumento(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todos los documentos por ID de la solicitud
         * @param {number} idSolicitudQuery Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDocumentos(idSolicitudQuery: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Documento>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDocumentos(idSolicitudQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener documento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumento(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Documento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumento(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar documento existente por ID
         * @param {number} id Identificador único
         * @param {Documento} documento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumento(id: number, documento: Documento, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Documento>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumento(id, documento, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentosApi - factory interface
 * @export
 */
export const DocumentosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentosApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo documento
         * @param {Documento} documento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumento(documento: Documento, options?: any): AxiosPromise<Documento> {
            return localVarFp.createDocumento(documento, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar documento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumento(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDocumento(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todos los documentos por ID de la solicitud
         * @param {number} idSolicitudQuery Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDocumentos(idSolicitudQuery: number, options?: any): AxiosPromise<Array<Documento>> {
            return localVarFp.getAllDocumentos(idSolicitudQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener documento por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumento(id: number, options?: any): AxiosPromise<Documento> {
            return localVarFp.getDocumento(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar documento existente por ID
         * @param {number} id Identificador único
         * @param {Documento} documento 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumento(id: number, documento: Documento, options?: any): AxiosPromise<Documento> {
            return localVarFp.updateDocumento(id, documento, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentosApi - object-oriented interface
 * @export
 * @class DocumentosApi
 * @extends {BaseAPI}
 */
export class DocumentosApi extends BaseAPI {
    /**
     * 
     * @summary Crear un nuevo documento
     * @param {Documento} documento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public createDocumento(documento: Documento, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).createDocumento(documento, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar documento por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public deleteDocumento(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).deleteDocumento(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todos los documentos por ID de la solicitud
     * @param {number} idSolicitudQuery Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public getAllDocumentos(idSolicitudQuery: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).getAllDocumentos(idSolicitudQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener documento por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public getDocumento(id: number, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).getDocumento(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar documento existente por ID
     * @param {number} id Identificador único
     * @param {Documento} documento 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentosApi
     */
    public updateDocumento(id: number, documento: Documento, options?: AxiosRequestConfig) {
        return DocumentosApiFp(this.configuration).updateDocumento(id, documento, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EstatusEvaluacionIndividualApi - axios parameter creator
 * @export
 */
export const EstatusEvaluacionIndividualApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtener el estatus de evaluación individual por ID de evaluación
         * @param {number} idEvaluacionIndividual Identificador único de la evaluación individual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstatusEvaluacionIndividualByIdEvaluacion: async (idEvaluacionIndividual: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idEvaluacionIndividual' is not null or undefined
            assertParamExists('getEstatusEvaluacionIndividualByIdEvaluacion', 'idEvaluacionIndividual', idEvaluacionIndividual)
            const localVarPath = `/estatus-evaluacion-individual/{idEvaluacionIndividual}`
                .replace(`{${"idEvaluacionIndividual"}}`, encodeURIComponent(String(idEvaluacionIndividual)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EstatusEvaluacionIndividualApi - functional programming interface
 * @export
 */
export const EstatusEvaluacionIndividualApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EstatusEvaluacionIndividualApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtener el estatus de evaluación individual por ID de evaluación
         * @param {number} idEvaluacionIndividual Identificador único de la evaluación individual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstatusEvaluacionIndividualByIdEvaluacion(idEvaluacionIndividual: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EstatusEvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstatusEvaluacionIndividualByIdEvaluacion(idEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EstatusEvaluacionIndividualApi - factory interface
 * @export
 */
export const EstatusEvaluacionIndividualApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EstatusEvaluacionIndividualApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtener el estatus de evaluación individual por ID de evaluación
         * @param {number} idEvaluacionIndividual Identificador único de la evaluación individual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstatusEvaluacionIndividualByIdEvaluacion(idEvaluacionIndividual: number, options?: any): AxiosPromise<Array<EstatusEvaluacionIndividual>> {
            return localVarFp.getEstatusEvaluacionIndividualByIdEvaluacion(idEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EstatusEvaluacionIndividualApi - object-oriented interface
 * @export
 * @class EstatusEvaluacionIndividualApi
 * @extends {BaseAPI}
 */
export class EstatusEvaluacionIndividualApi extends BaseAPI {
    /**
     * 
     * @summary Obtener el estatus de evaluación individual por ID de evaluación
     * @param {number} idEvaluacionIndividual Identificador único de la evaluación individual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstatusEvaluacionIndividualApi
     */
    public getEstatusEvaluacionIndividualByIdEvaluacion(idEvaluacionIndividual: number, options?: AxiosRequestConfig) {
        return EstatusEvaluacionIndividualApiFp(this.configuration).getEstatusEvaluacionIndividualByIdEvaluacion(idEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EstatusEvaluacionPlenariaApi - axios parameter creator
 * @export
 */
export const EstatusEvaluacionPlenariaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtener el estatus de evaluación plenaria por ID de evaluación
         * @param {number} idEvaluacionPlenaria Identificador único de la evaluación plenaria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstatusEvaluacionPlenariaByIdEvaluacion: async (idEvaluacionPlenaria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idEvaluacionPlenaria' is not null or undefined
            assertParamExists('getEstatusEvaluacionPlenariaByIdEvaluacion', 'idEvaluacionPlenaria', idEvaluacionPlenaria)
            const localVarPath = `/estatus-evaluacion-plenaria/{idEvaluacionPlenaria}`
                .replace(`{${"idEvaluacionPlenaria"}}`, encodeURIComponent(String(idEvaluacionPlenaria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EstatusEvaluacionPlenariaApi - functional programming interface
 * @export
 */
export const EstatusEvaluacionPlenariaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EstatusEvaluacionPlenariaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtener el estatus de evaluación plenaria por ID de evaluación
         * @param {number} idEvaluacionPlenaria Identificador único de la evaluación plenaria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstatusEvaluacionPlenariaByIdEvaluacion(idEvaluacionPlenaria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EstatusEvaluacionPlenaria>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstatusEvaluacionPlenariaByIdEvaluacion(idEvaluacionPlenaria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EstatusEvaluacionPlenariaApi - factory interface
 * @export
 */
export const EstatusEvaluacionPlenariaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EstatusEvaluacionPlenariaApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtener el estatus de evaluación plenaria por ID de evaluación
         * @param {number} idEvaluacionPlenaria Identificador único de la evaluación plenaria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstatusEvaluacionPlenariaByIdEvaluacion(idEvaluacionPlenaria: number, options?: any): AxiosPromise<Array<EstatusEvaluacionPlenaria>> {
            return localVarFp.getEstatusEvaluacionPlenariaByIdEvaluacion(idEvaluacionPlenaria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EstatusEvaluacionPlenariaApi - object-oriented interface
 * @export
 * @class EstatusEvaluacionPlenariaApi
 * @extends {BaseAPI}
 */
export class EstatusEvaluacionPlenariaApi extends BaseAPI {
    /**
     * 
     * @summary Obtener el estatus de evaluación plenaria por ID de evaluación
     * @param {number} idEvaluacionPlenaria Identificador único de la evaluación plenaria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstatusEvaluacionPlenariaApi
     */
    public getEstatusEvaluacionPlenariaByIdEvaluacion(idEvaluacionPlenaria: number, options?: AxiosRequestConfig) {
        return EstatusEvaluacionPlenariaApiFp(this.configuration).getEstatusEvaluacionPlenariaByIdEvaluacion(idEvaluacionPlenaria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EstatusSolicitudApi - axios parameter creator
 * @export
 */
export const EstatusSolicitudApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obtener todos los estatus de solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEstatusSolicitudByIdSolicitud: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getAllEstatusSolicitudByIdSolicitud', 'idSolicitud', idSolicitud)
            const localVarPath = `/estatus-solicitud/{idSolicitud}`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener el estatus activo de solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstatusSolicitudActivoByIdSolicitud: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getEstatusSolicitudActivoByIdSolicitud', 'idSolicitud', idSolicitud)
            const localVarPath = `/estatus-solicitud/{idSolicitud}/activo`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EstatusSolicitudApi - functional programming interface
 * @export
 */
export const EstatusSolicitudApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EstatusSolicitudApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obtener todos los estatus de solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEstatusSolicitudByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EstatusSolicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEstatusSolicitudByIdSolicitud(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener el estatus activo de solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstatusSolicitudActivoByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstatusSolicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstatusSolicitudActivoByIdSolicitud(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EstatusSolicitudApi - factory interface
 * @export
 */
export const EstatusSolicitudApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EstatusSolicitudApiFp(configuration)
    return {
        /**
         * 
         * @summary Obtener todos los estatus de solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEstatusSolicitudByIdSolicitud(idSolicitud: number, options?: any): AxiosPromise<Array<EstatusSolicitud>> {
            return localVarFp.getAllEstatusSolicitudByIdSolicitud(idSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener el estatus activo de solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstatusSolicitudActivoByIdSolicitud(idSolicitud: number, options?: any): AxiosPromise<EstatusSolicitud> {
            return localVarFp.getEstatusSolicitudActivoByIdSolicitud(idSolicitud, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EstatusSolicitudApi - object-oriented interface
 * @export
 * @class EstatusSolicitudApi
 * @extends {BaseAPI}
 */
export class EstatusSolicitudApi extends BaseAPI {
    /**
     * 
     * @summary Obtener todos los estatus de solicitud por ID de la solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstatusSolicitudApi
     */
    public getAllEstatusSolicitudByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig) {
        return EstatusSolicitudApiFp(this.configuration).getAllEstatusSolicitudByIdSolicitud(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener el estatus activo de solicitud por ID de la solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstatusSolicitudApi
     */
    public getEstatusSolicitudActivoByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig) {
        return EstatusSolicitudApiFp(this.configuration).getEstatusSolicitudActivoByIdSolicitud(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EvaluacionIndividualApi - axios parameter creator
 * @export
 */
export const EvaluacionIndividualApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva evaluación individual
         * @param {EvaluacionIndividual} evaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvaluacionIndividual: async (evaluacionIndividual: EvaluacionIndividual, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluacionIndividual' is not null or undefined
            assertParamExists('createEvaluacionIndividual', 'evaluacionIndividual', evaluacionIndividual)
            const localVarPath = `/evaluacion-individual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvaluacionIndividual: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEvaluacionIndividual', 'id', id)
            const localVarPath = `/evaluacion-individual/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marcar una evaluación individual como DESASIGNADA
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desasignarEvaluacionIndividual: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('desasignarEvaluacionIndividual', 'id', id)
            const localVarPath = `/evaluacion-individual/{id}/desasignar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
         * @summary Reasignar estatus ASIGNADA a una evaluación individual
         * @param {BitacoraDesfinalizacionEvaluacionIndividual} bitacoraDesfinalizacionEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desfinalizarEvaluacionIndividual: async (bitacoraDesfinalizacionEvaluacionIndividual: BitacoraDesfinalizacionEvaluacionIndividual, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bitacoraDesfinalizacionEvaluacionIndividual' is not null or undefined
            assertParamExists('desfinalizarEvaluacionIndividual', 'bitacoraDesfinalizacionEvaluacionIndividual', bitacoraDesfinalizacionEvaluacionIndividual)
            const localVarPath = `/evaluacion-individual/desfinalizar/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bitacoraDesfinalizacionEvaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finalizar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarEvaluacionIndividual: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('finalizarEvaluacionIndividual', 'id', id)
            const localVarPath = `/evaluacion-individual/enviar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales asignadas por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId: async (idUsuario: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idUsuario' is not null or undefined
            assertParamExists('getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId', 'idUsuario', idUsuario)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/evaluaciones-individuales-resumen/asignadas/usuario/{idUsuario}/convocatoria/{idConvocatoria}`
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(idUsuario)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de convocatoria
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesIndividualesByIdConvocatoria: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllEvaluacionesIndividualesByIdConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/evaluaciones-individuales/convocatoria/{idConvocatoria}`
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesIndividualesByIdSolicitud: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getAllEvaluacionesIndividualesByIdSolicitud', 'idSolicitud', idSolicitud)
            const localVarPath = `/evaluaciones-individuales/solicitud/{idSolicitud}`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId: async (idUsuario: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idUsuario' is not null or undefined
            assertParamExists('getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId', 'idUsuario', idUsuario)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/evaluaciones-individuales/usuario/{idUsuario}/convocatoria/{idConvocatoria}`
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(idUsuario)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId: async (idUsuario: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idUsuario' is not null or undefined
            assertParamExists('getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId', 'idUsuario', idUsuario)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/evaluaciones-individuales-resumen/usuario/{idUsuario}/convocatoria/{idConvocatoria}`
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(idUsuario)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluacionIndividual: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvaluacionIndividual', 'id', id)
            const localVarPath = `/evaluacion-individual/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las solicitudes con sus evaluadores individuales asignados para reporte
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitudesEvaluadoresIndividuales: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getSolicitudesEvaluadoresIndividuales', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/solicitudes-evaluadores-individuales/convocatoria/{idConvocatoria}`
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rechazar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {BitacoraRechazoEvaluacionIndividual} bitacoraRechazoEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazarEvaluacionIndividual: async (id: number, bitacoraRechazoEvaluacionIndividual: BitacoraRechazoEvaluacionIndividual, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rechazarEvaluacionIndividual', 'id', id)
            // verify required parameter 'bitacoraRechazoEvaluacionIndividual' is not null or undefined
            assertParamExists('rechazarEvaluacionIndividual', 'bitacoraRechazoEvaluacionIndividual', bitacoraRechazoEvaluacionIndividual)
            const localVarPath = `/evaluacion-individual/rechazar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bitacoraRechazoEvaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvaluacionIndividualApi - functional programming interface
 * @export
 */
export const EvaluacionIndividualApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvaluacionIndividualApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva evaluación individual
         * @param {EvaluacionIndividual} evaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvaluacionIndividual(evaluacionIndividual: EvaluacionIndividual, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvaluacionIndividual(evaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvaluacionIndividual(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvaluacionIndividual(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Marcar una evaluación individual como DESASIGNADA
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async desasignarEvaluacionIndividual(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.desasignarEvaluacionIndividual(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
         * @summary Reasignar estatus ASIGNADA a una evaluación individual
         * @param {BitacoraDesfinalizacionEvaluacionIndividual} bitacoraDesfinalizacionEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async desfinalizarEvaluacionIndividual(bitacoraDesfinalizacionEvaluacionIndividual: BitacoraDesfinalizacionEvaluacionIndividual, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.desfinalizarEvaluacionIndividual(bitacoraDesfinalizacionEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Finalizar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizarEvaluacionIndividual(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizarEvaluacionIndividual(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales asignadas por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvaluacionAsignadaResumen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de convocatoria
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEvaluacionesIndividualesByIdConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEvaluacionesIndividualesByIdConvocatoria(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEvaluacionesIndividualesByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEvaluacionesIndividualesByIdSolicitud(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VwResumenEvaluadoresIndividuales>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluacionIndividual(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluacionIndividual(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las solicitudes con sus evaluadores individuales asignados para reporte
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolicitudesEvaluadoresIndividuales(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSolicitudesEvaluadoresIndividuales(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Rechazar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {BitacoraRechazoEvaluacionIndividual} bitacoraRechazoEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rechazarEvaluacionIndividual(id: number, bitacoraRechazoEvaluacionIndividual: BitacoraRechazoEvaluacionIndividual, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rechazarEvaluacionIndividual(id, bitacoraRechazoEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EvaluacionIndividualApi - factory interface
 * @export
 */
export const EvaluacionIndividualApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvaluacionIndividualApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva evaluación individual
         * @param {EvaluacionIndividual} evaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvaluacionIndividual(evaluacionIndividual: EvaluacionIndividual, options?: any): AxiosPromise<EvaluacionIndividual> {
            return localVarFp.createEvaluacionIndividual(evaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvaluacionIndividual(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEvaluacionIndividual(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marcar una evaluación individual como DESASIGNADA
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desasignarEvaluacionIndividual(id: number, options?: any): AxiosPromise<EvaluacionIndividual> {
            return localVarFp.desasignarEvaluacionIndividual(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
         * @summary Reasignar estatus ASIGNADA a una evaluación individual
         * @param {BitacoraDesfinalizacionEvaluacionIndividual} bitacoraDesfinalizacionEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desfinalizarEvaluacionIndividual(bitacoraDesfinalizacionEvaluacionIndividual: BitacoraDesfinalizacionEvaluacionIndividual, options?: any): AxiosPromise<EvaluacionIndividual> {
            return localVarFp.desfinalizarEvaluacionIndividual(bitacoraDesfinalizacionEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finalizar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarEvaluacionIndividual(id: number, options?: any): AxiosPromise<EvaluacionIndividual> {
            return localVarFp.finalizarEvaluacionIndividual(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales asignadas por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: any): AxiosPromise<Array<EvaluacionAsignadaResumen>> {
            return localVarFp.getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de convocatoria
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesIndividualesByIdConvocatoria(idConvocatoria: number, options?: any): AxiosPromise<Array<EvaluacionIndividual>> {
            return localVarFp.getAllEvaluacionesIndividualesByIdConvocatoria(idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesIndividualesByIdSolicitud(idSolicitud: number, options?: any): AxiosPromise<Array<EvaluacionIndividual>> {
            return localVarFp.getAllEvaluacionesIndividualesByIdSolicitud(idSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: any): AxiosPromise<Array<EvaluacionIndividual>> {
            return localVarFp.getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: any): AxiosPromise<Array<VwResumenEvaluadoresIndividuales>> {
            return localVarFp.getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener evaluación individual por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluacionIndividual(id: number, options?: any): AxiosPromise<EvaluacionIndividual> {
            return localVarFp.getEvaluacionIndividual(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las solicitudes con sus evaluadores individuales asignados para reporte
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitudesEvaluadoresIndividuales(idConvocatoria: number, options?: any): AxiosPromise<any> {
            return localVarFp.getSolicitudesEvaluadoresIndividuales(idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rechazar evaluación individual por ID
         * @param {number} id Identificador único
         * @param {BitacoraRechazoEvaluacionIndividual} bitacoraRechazoEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rechazarEvaluacionIndividual(id: number, bitacoraRechazoEvaluacionIndividual: BitacoraRechazoEvaluacionIndividual, options?: any): AxiosPromise<EvaluacionIndividual> {
            return localVarFp.rechazarEvaluacionIndividual(id, bitacoraRechazoEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvaluacionIndividualApi - object-oriented interface
 * @export
 * @class EvaluacionIndividualApi
 * @extends {BaseAPI}
 */
export class EvaluacionIndividualApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva evaluación individual
     * @param {EvaluacionIndividual} evaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public createEvaluacionIndividual(evaluacionIndividual: EvaluacionIndividual, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).createEvaluacionIndividual(evaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar evaluación individual por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public deleteEvaluacionIndividual(id: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).deleteEvaluacionIndividual(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marcar una evaluación individual como DESASIGNADA
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public desasignarEvaluacionIndividual(id: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).desasignarEvaluacionIndividual(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
     * @summary Reasignar estatus ASIGNADA a una evaluación individual
     * @param {BitacoraDesfinalizacionEvaluacionIndividual} bitacoraDesfinalizacionEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public desfinalizarEvaluacionIndividual(bitacoraDesfinalizacionEvaluacionIndividual: BitacoraDesfinalizacionEvaluacionIndividual, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).desfinalizarEvaluacionIndividual(bitacoraDesfinalizacionEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finalizar evaluación individual por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public finalizarEvaluacionIndividual(id: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).finalizarEvaluacionIndividual(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones individuales asignadas por ID de usuario y convocatoria
     * @param {number} idUsuario Identificador único del usuario
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getAllEvaluacionesAsignadasByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones individuales por ID de convocatoria
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getAllEvaluacionesIndividualesByIdConvocatoria(idConvocatoria: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getAllEvaluacionesIndividualesByIdConvocatoria(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones individuales por ID de la solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getAllEvaluacionesIndividualesByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getAllEvaluacionesIndividualesByIdSolicitud(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
     * @param {number} idUsuario Identificador único del usuario
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getAllEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones individuales por ID de usuario y convocatoria
     * @param {number} idUsuario Identificador único del usuario
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getAllResumenEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener evaluación individual por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getEvaluacionIndividual(id: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getEvaluacionIndividual(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las solicitudes con sus evaluadores individuales asignados para reporte
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public getSolicitudesEvaluadoresIndividuales(idConvocatoria: number, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).getSolicitudesEvaluadoresIndividuales(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rechazar evaluación individual por ID
     * @param {number} id Identificador único
     * @param {BitacoraRechazoEvaluacionIndividual} bitacoraRechazoEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionIndividualApi
     */
    public rechazarEvaluacionIndividual(id: number, bitacoraRechazoEvaluacionIndividual: BitacoraRechazoEvaluacionIndividual, options?: AxiosRequestConfig) {
        return EvaluacionIndividualApiFp(this.configuration).rechazarEvaluacionIndividual(id, bitacoraRechazoEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EvaluacionPlenariaApi - axios parameter creator
 * @export
 */
export const EvaluacionPlenariaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva evaluación plenaria
         * @param {EvaluacionPlenaria} evaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvaluacionPlenaria: async (evaluacionPlenaria: EvaluacionPlenaria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluacionPlenaria' is not null or undefined
            assertParamExists('createEvaluacionPlenaria', 'evaluacionPlenaria', evaluacionPlenaria)
            const localVarPath = `/evaluacion-plenaria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluacionPlenaria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvaluacionPlenaria: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEvaluacionPlenaria', 'id', id)
            const localVarPath = `/evaluacion-plenaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
         * @summary Reasignar estatus ASIGNADA a una evaluación plenaria
         * @param {BitacoraDesfinalizacionEvaluacionPlenaria} bitacoraDesfinalizacionEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desfinalizarEvaluacionPlenaria: async (bitacoraDesfinalizacionEvaluacionPlenaria: BitacoraDesfinalizacionEvaluacionPlenaria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bitacoraDesfinalizacionEvaluacionPlenaria' is not null or undefined
            assertParamExists('desfinalizarEvaluacionPlenaria', 'bitacoraDesfinalizacionEvaluacionPlenaria', bitacoraDesfinalizacionEvaluacionPlenaria)
            const localVarPath = `/evaluacion-plenaria/desfinalizar/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bitacoraDesfinalizacionEvaluacionPlenaria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verificar si existe alguna evaluación plenaria ACTIVA por solicitudId
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsEvaluacionPlenariaBySolicitudId: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('existsEvaluacionPlenariaBySolicitudId', 'idSolicitud', idSolicitud)
            const localVarPath = `/evaluacion-plenaria/solicitudes/{idSolicitud}/exists`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finalizar evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarEvaluacionPlenaria: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('finalizarEvaluacionPlenaria', 'id', id)
            const localVarPath = `/evaluacion-plenaria/enviar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones plenarias por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesPlenariasByIdSolicitud: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getAllEvaluacionesPlenariasByIdSolicitud', 'idSolicitud', idSolicitud)
            const localVarPath = `/evaluaciones-plenarias/solicitud/{idSolicitud}`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones plenarias por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId: async (idUsuario: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idUsuario' is not null or undefined
            assertParamExists('getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId', 'idUsuario', idUsuario)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/evaluaciones-plenarias/usuario/{idUsuario}/convocatoria/{idConvocatoria}`
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(idUsuario)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluacionPlenaria: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvaluacionPlenaria', 'id', id)
            const localVarPath = `/evaluacion-plenaria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener evaluaciones por convocatoria (solicitudes con 2 evaluaciones individuales EVALUADA)
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {string} [nivel] Nivel SNI del participante
         * @param {boolean} [posicionPlenaria] Posición en la evaluación plenaria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumenEvaluacionesByConvocatoriaAndNivel: async (idConvocatoria: number, nivel?: string, posicionPlenaria?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getResumenEvaluacionesByConvocatoriaAndNivel', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/evaluaciones-plenarias/convocatoria/{idConvocatoria}`
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (nivel !== undefined) {
                localVarQueryParameter['nivel'] = nivel;
            }

            if (posicionPlenaria !== undefined) {
                localVarQueryParameter['posicionPlenaria'] = posicionPlenaria;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvaluacionPlenariaApi - functional programming interface
 * @export
 */
export const EvaluacionPlenariaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvaluacionPlenariaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva evaluación plenaria
         * @param {EvaluacionPlenaria} evaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvaluacionPlenaria(evaluacionPlenaria: EvaluacionPlenaria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvaluacionPlenaria(evaluacionPlenaria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvaluacionPlenaria(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvaluacionPlenaria(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
         * @summary Reasignar estatus ASIGNADA a una evaluación plenaria
         * @param {BitacoraDesfinalizacionEvaluacionPlenaria} bitacoraDesfinalizacionEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async desfinalizarEvaluacionPlenaria(bitacoraDesfinalizacionEvaluacionPlenaria: BitacoraDesfinalizacionEvaluacionPlenaria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.desfinalizarEvaluacionPlenaria(bitacoraDesfinalizacionEvaluacionPlenaria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verificar si existe alguna evaluación plenaria ACTIVA por solicitudId
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsEvaluacionPlenariaBySolicitudId(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsEvaluacionPlenariaBySolicitudId(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Finalizar evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizarEvaluacionPlenaria(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizarEvaluacionPlenaria(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones plenarias por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEvaluacionesPlenariasByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvaluacionPlenaria>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEvaluacionesPlenariasByIdSolicitud(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones plenarias por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvaluacionPlenaria>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluacionPlenaria(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluacionPlenaria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluacionPlenaria(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener evaluaciones por convocatoria (solicitudes con 2 evaluaciones individuales EVALUADA)
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {string} [nivel] Nivel SNI del participante
         * @param {boolean} [posicionPlenaria] Posición en la evaluación plenaria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResumenEvaluacionesByConvocatoriaAndNivel(idConvocatoria: number, nivel?: string, posicionPlenaria?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConvocatoriaEvaluacionResumen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResumenEvaluacionesByConvocatoriaAndNivel(idConvocatoria, nivel, posicionPlenaria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EvaluacionPlenariaApi - factory interface
 * @export
 */
export const EvaluacionPlenariaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvaluacionPlenariaApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva evaluación plenaria
         * @param {EvaluacionPlenaria} evaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvaluacionPlenaria(evaluacionPlenaria: EvaluacionPlenaria, options?: any): AxiosPromise<EvaluacionPlenaria> {
            return localVarFp.createEvaluacionPlenaria(evaluacionPlenaria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvaluacionPlenaria(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEvaluacionPlenaria(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
         * @summary Reasignar estatus ASIGNADA a una evaluación plenaria
         * @param {BitacoraDesfinalizacionEvaluacionPlenaria} bitacoraDesfinalizacionEvaluacionPlenaria 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desfinalizarEvaluacionPlenaria(bitacoraDesfinalizacionEvaluacionPlenaria: BitacoraDesfinalizacionEvaluacionPlenaria, options?: any): AxiosPromise<EvaluacionPlenaria> {
            return localVarFp.desfinalizarEvaluacionPlenaria(bitacoraDesfinalizacionEvaluacionPlenaria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verificar si existe alguna evaluación plenaria ACTIVA por solicitudId
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsEvaluacionPlenariaBySolicitudId(idSolicitud: number, options?: any): AxiosPromise<ExistsResponse> {
            return localVarFp.existsEvaluacionPlenariaBySolicitudId(idSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finalizar evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizarEvaluacionPlenaria(id: number, options?: any): AxiosPromise<EvaluacionPlenaria> {
            return localVarFp.finalizarEvaluacionPlenaria(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones plenarias por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesPlenariasByIdSolicitud(idSolicitud: number, options?: any): AxiosPromise<Array<EvaluacionPlenaria>> {
            return localVarFp.getAllEvaluacionesPlenariasByIdSolicitud(idSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las evaluaciones plenarias por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: any): AxiosPromise<Array<EvaluacionPlenaria>> {
            return localVarFp.getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener evaluación plenaria por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluacionPlenaria(id: number, options?: any): AxiosPromise<EvaluacionPlenaria> {
            return localVarFp.getEvaluacionPlenaria(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener evaluaciones por convocatoria (solicitudes con 2 evaluaciones individuales EVALUADA)
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {string} [nivel] Nivel SNI del participante
         * @param {boolean} [posicionPlenaria] Posición en la evaluación plenaria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumenEvaluacionesByConvocatoriaAndNivel(idConvocatoria: number, nivel?: string, posicionPlenaria?: boolean, options?: any): AxiosPromise<Array<ConvocatoriaEvaluacionResumen>> {
            return localVarFp.getResumenEvaluacionesByConvocatoriaAndNivel(idConvocatoria, nivel, posicionPlenaria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvaluacionPlenariaApi - object-oriented interface
 * @export
 * @class EvaluacionPlenariaApi
 * @extends {BaseAPI}
 */
export class EvaluacionPlenariaApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva evaluación plenaria
     * @param {EvaluacionPlenaria} evaluacionPlenaria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public createEvaluacionPlenaria(evaluacionPlenaria: EvaluacionPlenaria, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).createEvaluacionPlenaria(evaluacionPlenaria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar evaluación plenaria por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public deleteEvaluacionPlenaria(id: number, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).deleteEvaluacionPlenaria(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Desactiva el estatus activo actual (si existe), crea uno nuevo ASIGNADA y guarda bitácora de desfinalización con el comentario.
     * @summary Reasignar estatus ASIGNADA a una evaluación plenaria
     * @param {BitacoraDesfinalizacionEvaluacionPlenaria} bitacoraDesfinalizacionEvaluacionPlenaria 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public desfinalizarEvaluacionPlenaria(bitacoraDesfinalizacionEvaluacionPlenaria: BitacoraDesfinalizacionEvaluacionPlenaria, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).desfinalizarEvaluacionPlenaria(bitacoraDesfinalizacionEvaluacionPlenaria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verificar si existe alguna evaluación plenaria ACTIVA por solicitudId
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public existsEvaluacionPlenariaBySolicitudId(idSolicitud: number, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).existsEvaluacionPlenariaBySolicitudId(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finalizar evaluación plenaria por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public finalizarEvaluacionPlenaria(id: number, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).finalizarEvaluacionPlenaria(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones plenarias por ID de la solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public getAllEvaluacionesPlenariasByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).getAllEvaluacionesPlenariasByIdSolicitud(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las evaluaciones plenarias por ID de usuario y convocatoria
     * @param {number} idUsuario Identificador único del usuario
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).getAllEvaluacionesPlenariasByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener evaluación plenaria por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public getEvaluacionPlenaria(id: number, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).getEvaluacionPlenaria(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener evaluaciones por convocatoria (solicitudes con 2 evaluaciones individuales EVALUADA)
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {string} [nivel] Nivel SNI del participante
     * @param {boolean} [posicionPlenaria] Posición en la evaluación plenaria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvaluacionPlenariaApi
     */
    public getResumenEvaluacionesByConvocatoriaAndNivel(idConvocatoria: number, nivel?: string, posicionPlenaria?: boolean, options?: AxiosRequestConfig) {
        return EvaluacionPlenariaApiFp(this.configuration).getResumenEvaluacionesByConvocatoriaAndNivel(idConvocatoria, nivel, posicionPlenaria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobMonitoringApi - axios parameter creator
 * @export
 */
export const JobMonitoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Recuperar el estado de un job
         * @param {string} id ID del job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobStatus', 'id', id)
            const localVarPath = `/premios-job/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobMonitoringApi - functional programming interface
 * @export
 */
export const JobMonitoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobMonitoringApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Recuperar el estado de un job
         * @param {string} id ID del job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobMonitoringApi - factory interface
 * @export
 */
export const JobMonitoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobMonitoringApiFp(configuration)
    return {
        /**
         * 
         * @summary Recuperar el estado de un job
         * @param {string} id ID del job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStatus(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getJobStatus(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobMonitoringApi - object-oriented interface
 * @export
 * @class JobMonitoringApi
 * @extends {BaseAPI}
 */
export class JobMonitoringApi extends BaseAPI {
    /**
     * 
     * @summary Recuperar el estado de un job
     * @param {string} id ID del job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobMonitoringApi
     */
    public getJobStatus(id: string, options?: AxiosRequestConfig) {
        return JobMonitoringApiFp(this.configuration).getJobStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ParticipanteApi - axios parameter creator
 * @export
 */
export const ParticipanteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Buscar participante por CURP o CVU y Convocatoria
         * @param {string} dato CURP o CVU del participante
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipanteByCurpOrCvuAndConvocatoria: async (dato: string, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dato' is not null or undefined
            assertParamExists('getParticipanteByCurpOrCvuAndConvocatoria', 'dato', dato)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getParticipanteByCurpOrCvuAndConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/participantes/{dato}/convocatoria/{idConvocatoria}`
                .replace(`{${"dato"}}`, encodeURIComponent(String(dato)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saber si el participante ya fue ingresado previamente dentro de una convocatoria
         * @param {string} cvuParticipante Cvu del participante
         * @param {string} cvuPostulador Cvu del proponente
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantePrevio: async (cvuParticipante: string, cvuPostulador: string, idConvocatoria: number, envioSolicitud: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvuParticipante' is not null or undefined
            assertParamExists('getParticipantePrevio', 'cvuParticipante', cvuParticipante)
            // verify required parameter 'cvuPostulador' is not null or undefined
            assertParamExists('getParticipantePrevio', 'cvuPostulador', cvuPostulador)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getParticipantePrevio', 'idConvocatoria', idConvocatoria)
            // verify required parameter 'envioSolicitud' is not null or undefined
            assertParamExists('getParticipantePrevio', 'envioSolicitud', envioSolicitud)
            const localVarPath = `/participantes/previo/{cvuParticipante}/{cvuPostulador}/{idConvocatoria}`
                .replace(`{${"cvuParticipante"}}`, encodeURIComponent(String(cvuParticipante)))
                .replace(`{${"cvuPostulador"}}`, encodeURIComponent(String(cvuPostulador)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (envioSolicitud !== undefined) {
                localVarQueryParameter['envioSolicitud'] = envioSolicitud;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParticipanteApi - functional programming interface
 * @export
 */
export const ParticipanteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParticipanteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Buscar participante por CURP o CVU y Convocatoria
         * @param {string} dato CURP o CVU del participante
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParticipanteByCurpOrCvuAndConvocatoria(dato: string, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Participante>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParticipanteByCurpOrCvuAndConvocatoria(dato, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saber si el participante ya fue ingresado previamente dentro de una convocatoria
         * @param {string} cvuParticipante Cvu del participante
         * @param {string} cvuPostulador Cvu del proponente
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParticipantePrevio(cvuParticipante: string, cvuPostulador: string, idConvocatoria: number, envioSolicitud: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParticipantePrevio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParticipantePrevio(cvuParticipante, cvuPostulador, idConvocatoria, envioSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ParticipanteApi - factory interface
 * @export
 */
export const ParticipanteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParticipanteApiFp(configuration)
    return {
        /**
         * 
         * @summary Buscar participante por CURP o CVU y Convocatoria
         * @param {string} dato CURP o CVU del participante
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipanteByCurpOrCvuAndConvocatoria(dato: string, idConvocatoria: number, options?: any): AxiosPromise<Participante> {
            return localVarFp.getParticipanteByCurpOrCvuAndConvocatoria(dato, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saber si el participante ya fue ingresado previamente dentro de una convocatoria
         * @param {string} cvuParticipante Cvu del participante
         * @param {string} cvuPostulador Cvu del proponente
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantePrevio(cvuParticipante: string, cvuPostulador: string, idConvocatoria: number, envioSolicitud: boolean, options?: any): AxiosPromise<ParticipantePrevio> {
            return localVarFp.getParticipantePrevio(cvuParticipante, cvuPostulador, idConvocatoria, envioSolicitud, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParticipanteApi - object-oriented interface
 * @export
 * @class ParticipanteApi
 * @extends {BaseAPI}
 */
export class ParticipanteApi extends BaseAPI {
    /**
     * 
     * @summary Buscar participante por CURP o CVU y Convocatoria
     * @param {string} dato CURP o CVU del participante
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipanteApi
     */
    public getParticipanteByCurpOrCvuAndConvocatoria(dato: string, idConvocatoria: number, options?: AxiosRequestConfig) {
        return ParticipanteApiFp(this.configuration).getParticipanteByCurpOrCvuAndConvocatoria(dato, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saber si el participante ya fue ingresado previamente dentro de una convocatoria
     * @param {string} cvuParticipante Cvu del participante
     * @param {string} cvuPostulador Cvu del proponente
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipanteApi
     */
    public getParticipantePrevio(cvuParticipante: string, cvuPostulador: string, idConvocatoria: number, envioSolicitud: boolean, options?: AxiosRequestConfig) {
        return ParticipanteApiFp(this.configuration).getParticipantePrevio(cvuParticipante, cvuPostulador, idConvocatoria, envioSolicitud, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PersonasApi - axios parameter creator
 * @export
 */
export const PersonasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Eliminar una persona por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersona: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePersona', 'id', id)
            const localVarPath = `/personas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener una persona por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersona: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersona', 'id', id)
            const localVarPath = `/personas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar una persona existente por ID
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersona: async (id: number, persona: Persona, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePersona', 'id', id)
            // verify required parameter 'persona' is not null or undefined
            assertParamExists('updatePersona', 'persona', persona)
            const localVarPath = `/personas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persona, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonasApi - functional programming interface
 * @export
 */
export const PersonasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Eliminar una persona por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePersona(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePersona(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener una persona por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersona(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Persona>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersona(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar una persona existente por ID
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersona(id: number, persona: Persona, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Persona>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersona(id, persona, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PersonasApi - factory interface
 * @export
 */
export const PersonasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonasApiFp(configuration)
    return {
        /**
         * 
         * @summary Eliminar una persona por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersona(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePersona(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener una persona por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersona(id: number, options?: any): AxiosPromise<Persona> {
            return localVarFp.getPersona(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar una persona existente por ID
         * @param {number} id Identificador único
         * @param {Persona} persona 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersona(id: number, persona: Persona, options?: any): AxiosPromise<Persona> {
            return localVarFp.updatePersona(id, persona, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonasApi - object-oriented interface
 * @export
 * @class PersonasApi
 * @extends {BaseAPI}
 */
export class PersonasApi extends BaseAPI {
    /**
     * 
     * @summary Eliminar una persona por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonasApi
     */
    public deletePersona(id: number, options?: AxiosRequestConfig) {
        return PersonasApiFp(this.configuration).deletePersona(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener una persona por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonasApi
     */
    public getPersona(id: number, options?: AxiosRequestConfig) {
        return PersonasApiFp(this.configuration).getPersona(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar una persona existente por ID
     * @param {number} id Identificador único
     * @param {Persona} persona 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonasApi
     */
    public updatePersona(id: number, persona: Persona, options?: AxiosRequestConfig) {
        return PersonasApiFp(this.configuration).updatePersona(id, persona, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PreguntaDetalleEvaluacionIndividualApi - axios parameter creator
 * @export
 */
export const PreguntaDetalleEvaluacionIndividualApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva pregunta de evaluación individual
         * @param {Array<PreguntaDetalleEvaluacionIndividual>} preguntaDetalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreguntaDetalleEvaluacionIndividual: async (preguntaDetalleEvaluacionIndividual: Array<PreguntaDetalleEvaluacionIndividual>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preguntaDetalleEvaluacionIndividual' is not null or undefined
            assertParamExists('createPreguntaDetalleEvaluacionIndividual', 'preguntaDetalleEvaluacionIndividual', preguntaDetalleEvaluacionIndividual)
            const localVarPath = `/preguntas-detalle-evaluacion-individual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preguntaDetalleEvaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener pregunta por ID de DetalleEvaluacionIndividual
         * @param {number} idDetalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual: async (idDetalleEvaluacionIndividual: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDetalleEvaluacionIndividual' is not null or undefined
            assertParamExists('getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual', 'idDetalleEvaluacionIndividual', idDetalleEvaluacionIndividual)
            const localVarPath = `/preguntas-detalle-evaluacion-individual/{idDetalleEvaluacionIndividual}`
                .replace(`{${"idDetalleEvaluacionIndividual"}}`, encodeURIComponent(String(idDetalleEvaluacionIndividual)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreguntaDetalleEvaluacionIndividualApi - functional programming interface
 * @export
 */
export const PreguntaDetalleEvaluacionIndividualApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreguntaDetalleEvaluacionIndividualApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva pregunta de evaluación individual
         * @param {Array<PreguntaDetalleEvaluacionIndividual>} preguntaDetalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreguntaDetalleEvaluacionIndividual(preguntaDetalleEvaluacionIndividual: Array<PreguntaDetalleEvaluacionIndividual>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PreguntaDetalleEvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreguntaDetalleEvaluacionIndividual(preguntaDetalleEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener pregunta por ID de DetalleEvaluacionIndividual
         * @param {number} idDetalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual(idDetalleEvaluacionIndividual: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PreguntaDetalleEvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual(idDetalleEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PreguntaDetalleEvaluacionIndividualApi - factory interface
 * @export
 */
export const PreguntaDetalleEvaluacionIndividualApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreguntaDetalleEvaluacionIndividualApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva pregunta de evaluación individual
         * @param {Array<PreguntaDetalleEvaluacionIndividual>} preguntaDetalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreguntaDetalleEvaluacionIndividual(preguntaDetalleEvaluacionIndividual: Array<PreguntaDetalleEvaluacionIndividual>, options?: any): AxiosPromise<Array<PreguntaDetalleEvaluacionIndividual>> {
            return localVarFp.createPreguntaDetalleEvaluacionIndividual(preguntaDetalleEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener pregunta por ID de DetalleEvaluacionIndividual
         * @param {number} idDetalleEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual(idDetalleEvaluacionIndividual: number, options?: any): AxiosPromise<Array<PreguntaDetalleEvaluacionIndividual>> {
            return localVarFp.getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual(idDetalleEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreguntaDetalleEvaluacionIndividualApi - object-oriented interface
 * @export
 * @class PreguntaDetalleEvaluacionIndividualApi
 * @extends {BaseAPI}
 */
export class PreguntaDetalleEvaluacionIndividualApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva pregunta de evaluación individual
     * @param {Array<PreguntaDetalleEvaluacionIndividual>} preguntaDetalleEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreguntaDetalleEvaluacionIndividualApi
     */
    public createPreguntaDetalleEvaluacionIndividual(preguntaDetalleEvaluacionIndividual: Array<PreguntaDetalleEvaluacionIndividual>, options?: AxiosRequestConfig) {
        return PreguntaDetalleEvaluacionIndividualApiFp(this.configuration).createPreguntaDetalleEvaluacionIndividual(preguntaDetalleEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener pregunta por ID de DetalleEvaluacionIndividual
     * @param {number} idDetalleEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreguntaDetalleEvaluacionIndividualApi
     */
    public getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual(idDetalleEvaluacionIndividual: number, options?: AxiosRequestConfig) {
        return PreguntaDetalleEvaluacionIndividualApiFp(this.configuration).getAllPreguntasDetalleEvaluacionIndividualByIdDetalleEvaluacionIndividual(idDetalleEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProponentesApi - axios parameter creator
 * @export
 */
export const ProponentesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Eliminar un proponente por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProponente: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProponente', 'id', id)
            const localVarPath = `/proponentes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener un proponente por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProponente: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProponente', 'id', id)
            const localVarPath = `/proponentes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar un proponente existente por ID
         * @param {number} id Identificador único
         * @param {Proponente} proponente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProponente: async (id: number, proponente: Proponente, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProponente', 'id', id)
            // verify required parameter 'proponente' is not null or undefined
            assertParamExists('updateProponente', 'proponente', proponente)
            const localVarPath = `/proponentes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proponente, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProponentesApi - functional programming interface
 * @export
 */
export const ProponentesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProponentesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Eliminar un proponente por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProponente(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProponente(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener un proponente por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProponente(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Proponente>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProponente(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar un proponente existente por ID
         * @param {number} id Identificador único
         * @param {Proponente} proponente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProponente(id: number, proponente: Proponente, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Proponente>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProponente(id, proponente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProponentesApi - factory interface
 * @export
 */
export const ProponentesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProponentesApiFp(configuration)
    return {
        /**
         * 
         * @summary Eliminar un proponente por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProponente(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteProponente(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener un proponente por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProponente(id: number, options?: any): AxiosPromise<Proponente> {
            return localVarFp.getProponente(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar un proponente existente por ID
         * @param {number} id Identificador único
         * @param {Proponente} proponente 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProponente(id: number, proponente: Proponente, options?: any): AxiosPromise<Proponente> {
            return localVarFp.updateProponente(id, proponente, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProponentesApi - object-oriented interface
 * @export
 * @class ProponentesApi
 * @extends {BaseAPI}
 */
export class ProponentesApi extends BaseAPI {
    /**
     * 
     * @summary Eliminar un proponente por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProponentesApi
     */
    public deleteProponente(id: number, options?: AxiosRequestConfig) {
        return ProponentesApiFp(this.configuration).deleteProponente(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener un proponente por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProponentesApi
     */
    public getProponente(id: number, options?: AxiosRequestConfig) {
        return ProponentesApiFp(this.configuration).getProponente(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar un proponente existente por ID
     * @param {number} id Identificador único
     * @param {Proponente} proponente 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProponentesApi
     */
    public updateProponente(id: number, proponente: Proponente, options?: AxiosRequestConfig) {
        return ProponentesApiFp(this.configuration).updateProponente(id, proponente, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReportesApi - axios parameter creator
 * @export
 */
export const ReportesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtiene los reportes de Premios
         * @param {number} id Identificador único
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportesPremios: async (id: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReportesPremios', 'id', id)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getReportesPremios', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/reportes-premios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idConvocatoria !== undefined) {
                localVarQueryParameter['idConvocatoria'] = idConvocatoria;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportesApi - functional programming interface
 * @export
 */
export const ReportesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportesApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtiene los reportes de Premios
         * @param {number} id Identificador único
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportesPremios(id: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportesPremios(id, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportesApi - factory interface
 * @export
 */
export const ReportesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportesApiFp(configuration)
    return {
        /**
         * Obtiene los reportes de Premios
         * @param {number} id Identificador único
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportesPremios(id: number, idConvocatoria: number, options?: any): AxiosPromise<any> {
            return localVarFp.getReportesPremios(id, idConvocatoria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportesApi - object-oriented interface
 * @export
 * @class ReportesApi
 * @extends {BaseAPI}
 */
export class ReportesApi extends BaseAPI {
    /**
     * Obtiene los reportes de Premios
     * @param {number} id Identificador único
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportesApi
     */
    public getReportesPremios(id: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return ReportesApiFp(this.configuration).getReportesPremios(id, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SolicitudesApi - axios parameter creator
 * @export
 */
export const SolicitudesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva solicitud
         * @param {Solicitud} solicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolicitud: async (solicitud: Solicitud, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'solicitud' is not null or undefined
            assertParamExists('createSolicitud', 'solicitud', solicitud)
            const localVarPath = `/solicitudes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solicitud, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar una solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSolicitud: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSolicitud', 'id', id)
            const localVarPath = `/solicitudes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enviar una solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarSolicitud: async (idSolicitud: number, inlineObject: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('enviarSolicitud', 'idSolicitud', idSolicitud)
            // verify required parameter 'inlineObject' is not null or undefined
            assertParamExists('enviarSolicitud', 'inlineObject', inlineObject)
            const localVarPath = `/solicitudes/{idSolicitud}/enviar`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generar un nuevo folio para una solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generarFolioSolicitud: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes/generar-folio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las solicitudes para el administrador
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/solicitudes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las solicitudes por cvu del proponente
         * @param {string} cvuProponente Cvu del proponente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudesByCvuProponente: async (cvuProponente: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvuProponente' is not null or undefined
            assertParamExists('getAllSolicitudesByCvuProponente', 'cvuProponente', cvuProponente)
            const localVarPath = `/solicitudes/proponente/{cvuProponente}`
                .replace(`{${"cvuProponente"}}`, encodeURIComponent(String(cvuProponente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las solicitudes por cvu del proponente y id de la convocatoria
         * @param {string} cvuProponente Cvu del proponente
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudesByCvuProponenteAndConvocatoria: async (cvuProponente: string, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvuProponente' is not null or undefined
            assertParamExists('getAllSolicitudesByCvuProponenteAndConvocatoria', 'cvuProponente', cvuProponente)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllSolicitudesByCvuProponenteAndConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/solicitudes/proponente/{cvuProponente}/convocatoria/{idConvocatoria}`
                .replace(`{${"cvuProponente"}}`, encodeURIComponent(String(cvuProponente)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Listado ligero de solicitudes para el administrador
         * @param {number} idConvocatoria ID de la convocatoria para filtrar las solicitudes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoPostulantesLigero: async (idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getListadoPostulantesLigero', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/solicitudes/admin/listado`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (idConvocatoria !== undefined) {
                localVarQueryParameter['idConvocatoria'] = idConvocatoria;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener PDF de una solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
         * @param {string} [folio] Folio de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfSolicitud: async (idSolicitud: number, envioSolicitud: boolean, folio?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getPdfSolicitud', 'idSolicitud', idSolicitud)
            // verify required parameter 'envioSolicitud' is not null or undefined
            assertParamExists('getPdfSolicitud', 'envioSolicitud', envioSolicitud)
            const localVarPath = `/solicitudes/{idSolicitud}/pdf`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (envioSolicitud !== undefined) {
                localVarQueryParameter['envioSolicitud'] = envioSolicitud;
            }

            if (folio !== undefined) {
                localVarQueryParameter['folio'] = folio;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitud: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSolicitud', 'id', id)
            const localVarPath = `/solicitudes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SolicitudesApi - functional programming interface
 * @export
 */
export const SolicitudesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SolicitudesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva solicitud
         * @param {Solicitud} solicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSolicitud(solicitud: Solicitud, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Solicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSolicitud(solicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar una solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSolicitud(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSolicitud(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enviar una solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enviarSolicitud(idSolicitud: number, inlineObject: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Solicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enviarSolicitud(idSolicitud, inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generar un nuevo folio para una solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generarFolioSolicitud(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generarFolioSolicitud(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las solicitudes para el administrador
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSolicitudes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSolicitudes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las solicitudes por cvu del proponente
         * @param {string} cvuProponente Cvu del proponente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSolicitudesByCvuProponente(cvuProponente: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSolicitudesByCvuProponente(cvuProponente, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las solicitudes por cvu del proponente y id de la convocatoria
         * @param {string} cvuProponente Cvu del proponente
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSolicitudesByCvuProponenteAndConvocatoria(cvuProponente: string, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Solicitud>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSolicitudesByCvuProponenteAndConvocatoria(cvuProponente, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Listado ligero de solicitudes para el administrador
         * @param {number} idConvocatoria ID de la convocatoria para filtrar las solicitudes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListadoPostulantesLigero(idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SolicitudPostulante>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListadoPostulantesLigero(idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener PDF de una solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
         * @param {string} [folio] Folio de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdfSolicitud(idSolicitud: number, envioSolicitud: boolean, folio?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentoExport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdfSolicitud(idSolicitud, envioSolicitud, folio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSolicitud(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Solicitud>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSolicitud(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SolicitudesApi - factory interface
 * @export
 */
export const SolicitudesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SolicitudesApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva solicitud
         * @param {Solicitud} solicitud 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSolicitud(solicitud: Solicitud, options?: any): AxiosPromise<Solicitud> {
            return localVarFp.createSolicitud(solicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar una solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSolicitud(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSolicitud(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enviar una solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enviarSolicitud(idSolicitud: number, inlineObject: InlineObject, options?: any): AxiosPromise<Solicitud> {
            return localVarFp.enviarSolicitud(idSolicitud, inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generar un nuevo folio para una solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generarFolioSolicitud(options?: any): AxiosPromise<string> {
            return localVarFp.generarFolioSolicitud(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las solicitudes para el administrador
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudes(options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getAllSolicitudes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las solicitudes por cvu del proponente
         * @param {string} cvuProponente Cvu del proponente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudesByCvuProponente(cvuProponente: string, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getAllSolicitudesByCvuProponente(cvuProponente, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las solicitudes por cvu del proponente y id de la convocatoria
         * @param {string} cvuProponente Cvu del proponente
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSolicitudesByCvuProponenteAndConvocatoria(cvuProponente: string, idConvocatoria: number, options?: any): AxiosPromise<Array<Solicitud>> {
            return localVarFp.getAllSolicitudesByCvuProponenteAndConvocatoria(cvuProponente, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listado ligero de solicitudes para el administrador
         * @param {number} idConvocatoria ID de la convocatoria para filtrar las solicitudes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListadoPostulantesLigero(idConvocatoria: number, options?: any): AxiosPromise<Array<SolicitudPostulante>> {
            return localVarFp.getListadoPostulantesLigero(idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener PDF de una solicitud por ID de la solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
         * @param {string} [folio] Folio de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfSolicitud(idSolicitud: number, envioSolicitud: boolean, folio?: string, options?: any): AxiosPromise<DocumentoExport> {
            return localVarFp.getPdfSolicitud(idSolicitud, envioSolicitud, folio, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener solicitud por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSolicitud(id: number, options?: any): AxiosPromise<Solicitud> {
            return localVarFp.getSolicitud(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SolicitudesApi - object-oriented interface
 * @export
 * @class SolicitudesApi
 * @extends {BaseAPI}
 */
export class SolicitudesApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva solicitud
     * @param {Solicitud} solicitud 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public createSolicitud(solicitud: Solicitud, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).createSolicitud(solicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar una solicitud por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public deleteSolicitud(id: number, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).deleteSolicitud(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enviar una solicitud por ID de la solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {InlineObject} inlineObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public enviarSolicitud(idSolicitud: number, inlineObject: InlineObject, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).enviarSolicitud(idSolicitud, inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generar un nuevo folio para una solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public generarFolioSolicitud(options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).generarFolioSolicitud(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las solicitudes para el administrador
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public getAllSolicitudes(options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).getAllSolicitudes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las solicitudes por cvu del proponente
     * @param {string} cvuProponente Cvu del proponente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public getAllSolicitudesByCvuProponente(cvuProponente: string, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).getAllSolicitudesByCvuProponente(cvuProponente, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las solicitudes por cvu del proponente y id de la convocatoria
     * @param {string} cvuProponente Cvu del proponente
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public getAllSolicitudesByCvuProponenteAndConvocatoria(cvuProponente: string, idConvocatoria: number, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).getAllSolicitudesByCvuProponenteAndConvocatoria(cvuProponente, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listado ligero de solicitudes para el administrador
     * @param {number} idConvocatoria ID de la convocatoria para filtrar las solicitudes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public getListadoPostulantesLigero(idConvocatoria: number, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).getListadoPostulantesLigero(idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener PDF de una solicitud por ID de la solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {boolean} envioSolicitud Indica si se debe enviar la solicitud
     * @param {string} [folio] Folio de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public getPdfSolicitud(idSolicitud: number, envioSolicitud: boolean, folio?: string, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).getPdfSolicitud(idSolicitud, envioSolicitud, folio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener solicitud por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SolicitudesApi
     */
    public getSolicitud(id: number, options?: AxiosRequestConfig) {
        return SolicitudesApiFp(this.configuration).getSolicitud(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TermCondEvaluacionIndividualApi - axios parameter creator
 * @export
 */
export const TermCondEvaluacionIndividualApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva Terminos y Condiciones Terminos y Condiciones Evaluación individual
         * @param {TermCondEvaluacionIndividual} termCondEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTermCondEvaluacionIndividual: async (termCondEvaluacionIndividual: TermCondEvaluacionIndividual, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termCondEvaluacionIndividual' is not null or undefined
            assertParamExists('createTermCondEvaluacionIndividual', 'termCondEvaluacionIndividual', termCondEvaluacionIndividual)
            const localVarPath = `/term-cond-evaluacion-individual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(termCondEvaluacionIndividual, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas los term y cond evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId: async (idUsuario: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idUsuario' is not null or undefined
            assertParamExists('getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId', 'idUsuario', idUsuario)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/term-cond-evaluacion-individual/usuario/{idUsuario}/convocatoria/{idConvocatoria}`
                .replace(`{${"idUsuario"}}`, encodeURIComponent(String(idUsuario)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermCondEvaluacionIndividualApi - functional programming interface
 * @export
 */
export const TermCondEvaluacionIndividualApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermCondEvaluacionIndividualApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva Terminos y Condiciones Terminos y Condiciones Evaluación individual
         * @param {TermCondEvaluacionIndividual} termCondEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTermCondEvaluacionIndividual(termCondEvaluacionIndividual: TermCondEvaluacionIndividual, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermCondEvaluacionIndividual>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTermCondEvaluacionIndividual(termCondEvaluacionIndividual, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas los term y cond evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TermCondEvaluacionIndividual>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TermCondEvaluacionIndividualApi - factory interface
 * @export
 */
export const TermCondEvaluacionIndividualApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermCondEvaluacionIndividualApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva Terminos y Condiciones Terminos y Condiciones Evaluación individual
         * @param {TermCondEvaluacionIndividual} termCondEvaluacionIndividual 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTermCondEvaluacionIndividual(termCondEvaluacionIndividual: TermCondEvaluacionIndividual, options?: any): AxiosPromise<TermCondEvaluacionIndividual> {
            return localVarFp.createTermCondEvaluacionIndividual(termCondEvaluacionIndividual, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas los term y cond evaluaciones individuales por ID de usuario y convocatoria
         * @param {number} idUsuario Identificador único del usuario
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: any): AxiosPromise<Array<TermCondEvaluacionIndividual>> {
            return localVarFp.getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermCondEvaluacionIndividualApi - object-oriented interface
 * @export
 * @class TermCondEvaluacionIndividualApi
 * @extends {BaseAPI}
 */
export class TermCondEvaluacionIndividualApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva Terminos y Condiciones Terminos y Condiciones Evaluación individual
     * @param {TermCondEvaluacionIndividual} termCondEvaluacionIndividual 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermCondEvaluacionIndividualApi
     */
    public createTermCondEvaluacionIndividual(termCondEvaluacionIndividual: TermCondEvaluacionIndividual, options?: AxiosRequestConfig) {
        return TermCondEvaluacionIndividualApiFp(this.configuration).createTermCondEvaluacionIndividual(termCondEvaluacionIndividual, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas los term y cond evaluaciones individuales por ID de usuario y convocatoria
     * @param {number} idUsuario Identificador único del usuario
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermCondEvaluacionIndividualApi
     */
    public getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return TermCondEvaluacionIndividualApiFp(this.configuration).getAllTermCondEvaluacionesIndividualesByUsuarioIdAndConvocatoriaId(idUsuario, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsuarioRolApi - axios parameter creator
 * @export
 */
export const UsuarioRolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una relación Usuario-Rol
         * @param {UsuarioRol} usuarioRol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsuarioRol: async (usuarioRol: UsuarioRol, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usuarioRol' is not null or undefined
            assertParamExists('createUsuarioRol', 'usuarioRol', usuarioRol)
            const localVarPath = `/usuario-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usuarioRol, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsuarioRolById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUsuarioRolById', 'id', id)
            const localVarPath = `/usuario-roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioRolById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUsuarioRolById', 'id', id)
            const localVarPath = `/usuario-roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las relaciones Usuario-Rol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioRoles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/usuario-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Listar relaciones Usuario-Rol por rol y convocatoria
         * @param {number} rolId ID del rol
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosRolByRolAndConvocatoria: async (rolId: number, idConvocatoria: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rolId' is not null or undefined
            assertParamExists('getUsuariosRolByRolAndConvocatoria', 'rolId', rolId)
            // verify required parameter 'idConvocatoria' is not null or undefined
            assertParamExists('getUsuariosRolByRolAndConvocatoria', 'idConvocatoria', idConvocatoria)
            const localVarPath = `/usuario-roles/{rolId}/convocatorias/{idConvocatoria}/usuarios`
                .replace(`{${"rolId"}}`, encodeURIComponent(String(rolId)))
                .replace(`{${"idConvocatoria"}}`, encodeURIComponent(String(idConvocatoria)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {UsuarioRol} usuarioRol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsuarioRolById: async (id: number, usuarioRol: UsuarioRol, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUsuarioRolById', 'id', id)
            // verify required parameter 'usuarioRol' is not null or undefined
            assertParamExists('updateUsuarioRolById', 'usuarioRol', usuarioRol)
            const localVarPath = `/usuario-roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usuarioRol, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsuarioRolApi - functional programming interface
 * @export
 */
export const UsuarioRolApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsuarioRolApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una relación Usuario-Rol
         * @param {UsuarioRol} usuarioRol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsuarioRol(usuarioRol: UsuarioRol, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsuarioRol>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsuarioRol(usuarioRol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsuarioRolById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsuarioRolById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioRolById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsuarioRol>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioRolById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las relaciones Usuario-Rol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioRoles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UsuarioRol>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioRoles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Listar relaciones Usuario-Rol por rol y convocatoria
         * @param {number} rolId ID del rol
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuariosRolByRolAndConvocatoria(rolId: number, idConvocatoria: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UsuarioRol>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuariosRolByRolAndConvocatoria(rolId, idConvocatoria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {UsuarioRol} usuarioRol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsuarioRolById(id: number, usuarioRol: UsuarioRol, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsuarioRol>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsuarioRolById(id, usuarioRol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsuarioRolApi - factory interface
 * @export
 */
export const UsuarioRolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsuarioRolApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una relación Usuario-Rol
         * @param {UsuarioRol} usuarioRol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsuarioRol(usuarioRol: UsuarioRol, options?: any): AxiosPromise<UsuarioRol> {
            return localVarFp.createUsuarioRol(usuarioRol, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsuarioRolById(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUsuarioRolById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioRolById(id: number, options?: any): AxiosPromise<UsuarioRol> {
            return localVarFp.getUsuarioRolById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las relaciones Usuario-Rol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioRoles(options?: any): AxiosPromise<Array<UsuarioRol>> {
            return localVarFp.getUsuarioRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Listar relaciones Usuario-Rol por rol y convocatoria
         * @param {number} rolId ID del rol
         * @param {number} idConvocatoria Identificador único de la convocatoria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuariosRolByRolAndConvocatoria(rolId: number, idConvocatoria: number, options?: any): AxiosPromise<Array<UsuarioRol>> {
            return localVarFp.getUsuariosRolByRolAndConvocatoria(rolId, idConvocatoria, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar una relación Usuario-Rol por ID
         * @param {number} id Identificador único
         * @param {UsuarioRol} usuarioRol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsuarioRolById(id: number, usuarioRol: UsuarioRol, options?: any): AxiosPromise<UsuarioRol> {
            return localVarFp.updateUsuarioRolById(id, usuarioRol, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsuarioRolApi - object-oriented interface
 * @export
 * @class UsuarioRolApi
 * @extends {BaseAPI}
 */
export class UsuarioRolApi extends BaseAPI {
    /**
     * 
     * @summary Crear una relación Usuario-Rol
     * @param {UsuarioRol} usuarioRol 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuarioRolApi
     */
    public createUsuarioRol(usuarioRol: UsuarioRol, options?: AxiosRequestConfig) {
        return UsuarioRolApiFp(this.configuration).createUsuarioRol(usuarioRol, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar una relación Usuario-Rol por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuarioRolApi
     */
    public deleteUsuarioRolById(id: number, options?: AxiosRequestConfig) {
        return UsuarioRolApiFp(this.configuration).deleteUsuarioRolById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener una relación Usuario-Rol por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuarioRolApi
     */
    public getUsuarioRolById(id: number, options?: AxiosRequestConfig) {
        return UsuarioRolApiFp(this.configuration).getUsuarioRolById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las relaciones Usuario-Rol
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuarioRolApi
     */
    public getUsuarioRoles(options?: AxiosRequestConfig) {
        return UsuarioRolApiFp(this.configuration).getUsuarioRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Listar relaciones Usuario-Rol por rol y convocatoria
     * @param {number} rolId ID del rol
     * @param {number} idConvocatoria Identificador único de la convocatoria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuarioRolApi
     */
    public getUsuariosRolByRolAndConvocatoria(rolId: number, idConvocatoria: number, options?: AxiosRequestConfig) {
        return UsuarioRolApiFp(this.configuration).getUsuariosRolByRolAndConvocatoria(rolId, idConvocatoria, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar una relación Usuario-Rol por ID
     * @param {number} id Identificador único
     * @param {UsuarioRol} usuarioRol 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuarioRolApi
     */
    public updateUsuarioRolById(id: number, usuarioRol: UsuarioRol, options?: AxiosRequestConfig) {
        return UsuarioRolApiFp(this.configuration).updateUsuarioRolById(id, usuarioRol, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsuariosApi - axios parameter creator
 * @export
 */
export const UsuariosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear un nuevo usuario
         * @param {Usuario} usuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsuario: async (usuario: Usuario, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usuario' is not null or undefined
            assertParamExists('createUsuario', 'usuario', usuario)
            const localVarPath = `/usuarios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usuario, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Eliminar un usuario por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsuarioById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUsuarioById', 'id', id)
            const localVarPath = `/usuarios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener un usuario por CVU
         * @param {string} cvu Cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioByCvu: async (cvu: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cvu' is not null or undefined
            assertParamExists('getUsuarioByCvu', 'cvu', cvu)
            const localVarPath = `/usuarios/cvu/{cvu}`
                .replace(`{${"cvu"}}`, encodeURIComponent(String(cvu)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener un usuario por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUsuarioById', 'id', id)
            const localVarPath = `/usuarios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todos los usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarios: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/usuarios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar un usuario por ID
         * @param {number} id Identificador único
         * @param {Usuario} usuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsuarioById: async (id: number, usuario: Usuario, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUsuarioById', 'id', id)
            // verify required parameter 'usuario' is not null or undefined
            assertParamExists('updateUsuarioById', 'usuario', usuario)
            const localVarPath = `/usuarios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usuario, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsuariosApi - functional programming interface
 * @export
 */
export const UsuariosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsuariosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo usuario
         * @param {Usuario} usuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUsuario(usuario: Usuario, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Usuario>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsuario(usuario, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Eliminar un usuario por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsuarioById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsuarioById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener un usuario por CVU
         * @param {string} cvu Cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioByCvu(cvu: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Usuario>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioByCvu(cvu, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener un usuario por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarioById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Usuario>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarioById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todos los usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsuarios(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Usuario>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsuarios(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar un usuario por ID
         * @param {number} id Identificador único
         * @param {Usuario} usuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsuarioById(id: number, usuario: Usuario, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Usuario>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsuarioById(id, usuario, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsuariosApi - factory interface
 * @export
 */
export const UsuariosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsuariosApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear un nuevo usuario
         * @param {Usuario} usuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsuario(usuario: Usuario, options?: any): AxiosPromise<Usuario> {
            return localVarFp.createUsuario(usuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Eliminar un usuario por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsuarioById(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUsuarioById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener un usuario por CVU
         * @param {string} cvu Cvu del usuario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioByCvu(cvu: string, options?: any): AxiosPromise<Usuario> {
            return localVarFp.getUsuarioByCvu(cvu, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener un usuario por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarioById(id: number, options?: any): AxiosPromise<Usuario> {
            return localVarFp.getUsuarioById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todos los usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsuarios(options?: any): AxiosPromise<Array<Usuario>> {
            return localVarFp.getUsuarios(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar un usuario por ID
         * @param {number} id Identificador único
         * @param {Usuario} usuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsuarioById(id: number, usuario: Usuario, options?: any): AxiosPromise<Usuario> {
            return localVarFp.updateUsuarioById(id, usuario, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsuariosApi - object-oriented interface
 * @export
 * @class UsuariosApi
 * @extends {BaseAPI}
 */
export class UsuariosApi extends BaseAPI {
    /**
     * 
     * @summary Crear un nuevo usuario
     * @param {Usuario} usuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuariosApi
     */
    public createUsuario(usuario: Usuario, options?: AxiosRequestConfig) {
        return UsuariosApiFp(this.configuration).createUsuario(usuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Eliminar un usuario por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuariosApi
     */
    public deleteUsuarioById(id: number, options?: AxiosRequestConfig) {
        return UsuariosApiFp(this.configuration).deleteUsuarioById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener un usuario por CVU
     * @param {string} cvu Cvu del usuario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuariosApi
     */
    public getUsuarioByCvu(cvu: string, options?: AxiosRequestConfig) {
        return UsuariosApiFp(this.configuration).getUsuarioByCvu(cvu, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener un usuario por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuariosApi
     */
    public getUsuarioById(id: number, options?: AxiosRequestConfig) {
        return UsuariosApiFp(this.configuration).getUsuarioById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todos los usuarios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuariosApi
     */
    public getUsuarios(options?: AxiosRequestConfig) {
        return UsuariosApiFp(this.configuration).getUsuarios(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar un usuario por ID
     * @param {number} id Identificador único
     * @param {Usuario} usuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsuariosApi
     */
    public updateUsuarioById(id: number, usuario: Usuario, options?: AxiosRequestConfig) {
        return UsuariosApiFp(this.configuration).updateUsuarioById(id, usuario, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ValidacionDocumentalApi - axios parameter creator
 * @export
 */
export const ValidacionDocumentalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Crear una nueva validación documental
         * @param {ValidacionDocumental} validacionDocumental 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createValidacionDocumental: async (validacionDocumental: ValidacionDocumental, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validacionDocumental' is not null or undefined
            assertParamExists('createValidacionDocumental', 'validacionDocumental', validacionDocumental)
            const localVarPath = `/validacion-documental`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validacionDocumental, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener todas las validaciones documentales
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidacionesDocumentales: async (page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/validacion-documental`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener validación documental por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionDocumentalById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getValidacionDocumentalById', 'id', id)
            const localVarPath = `/validacion-documental/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener validaciones documentales por ID de solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionDocumentalByIdSolicitud: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getValidacionDocumentalByIdSolicitud', 'idSolicitud', idSolicitud)
            const localVarPath = `/validacion-documental/solicitud/{idSolicitud}`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener historial de validaciones documentales por ID de solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionDocumentalHistoricoByIdSolicitud: async (idSolicitud: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idSolicitud' is not null or undefined
            assertParamExists('getValidacionDocumentalHistoricoByIdSolicitud', 'idSolicitud', idSolicitud)
            const localVarPath = `/validacion-documental/solicitud/historico/{idSolicitud}`
                .replace(`{${"idSolicitud"}}`, encodeURIComponent(String(idSolicitud)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar validación documental por ID
         * @param {number} id Identificador único
         * @param {ValidacionDocumental} validacionDocumental 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateValidacionDocumentalById: async (id: number, validacionDocumental: ValidacionDocumental, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateValidacionDocumentalById', 'id', id)
            // verify required parameter 'validacionDocumental' is not null or undefined
            assertParamExists('updateValidacionDocumentalById', 'validacionDocumental', validacionDocumental)
            const localVarPath = `/validacion-documental/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", ["jhipster", "email", "profile"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validacionDocumental, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidacionDocumentalApi - functional programming interface
 * @export
 */
export const ValidacionDocumentalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidacionDocumentalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva validación documental
         * @param {ValidacionDocumental} validacionDocumental 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createValidacionDocumental(validacionDocumental: ValidacionDocumental, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidacionDocumental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createValidacionDocumental(validacionDocumental, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener todas las validaciones documentales
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllValidacionesDocumentales(page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidacionDocumental>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllValidacionesDocumentales(page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener validación documental por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidacionDocumentalById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidacionDocumental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidacionDocumentalById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener validaciones documentales por ID de solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidacionDocumentalByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidacionDocumental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidacionDocumentalByIdSolicitud(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Obtener historial de validaciones documentales por ID de solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidacionDocumentalHistoricoByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidacionDocumental>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidacionDocumentalHistoricoByIdSolicitud(idSolicitud, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Actualizar validación documental por ID
         * @param {number} id Identificador único
         * @param {ValidacionDocumental} validacionDocumental 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateValidacionDocumentalById(id: number, validacionDocumental: ValidacionDocumental, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidacionDocumental>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateValidacionDocumentalById(id, validacionDocumental, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ValidacionDocumentalApi - factory interface
 * @export
 */
export const ValidacionDocumentalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidacionDocumentalApiFp(configuration)
    return {
        /**
         * 
         * @summary Crear una nueva validación documental
         * @param {ValidacionDocumental} validacionDocumental 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createValidacionDocumental(validacionDocumental: ValidacionDocumental, options?: any): AxiosPromise<ValidacionDocumental> {
            return localVarFp.createValidacionDocumental(validacionDocumental, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener todas las validaciones documentales
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllValidacionesDocumentales(page?: number, size?: number, options?: any): AxiosPromise<Array<ValidacionDocumental>> {
            return localVarFp.getAllValidacionesDocumentales(page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener validación documental por ID
         * @param {number} id Identificador único
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionDocumentalById(id: number, options?: any): AxiosPromise<ValidacionDocumental> {
            return localVarFp.getValidacionDocumentalById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener validaciones documentales por ID de solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionDocumentalByIdSolicitud(idSolicitud: number, options?: any): AxiosPromise<ValidacionDocumental> {
            return localVarFp.getValidacionDocumentalByIdSolicitud(idSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener historial de validaciones documentales por ID de solicitud
         * @param {number} idSolicitud Identificador único de la solicitud
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidacionDocumentalHistoricoByIdSolicitud(idSolicitud: number, options?: any): AxiosPromise<Array<ValidacionDocumental>> {
            return localVarFp.getValidacionDocumentalHistoricoByIdSolicitud(idSolicitud, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar validación documental por ID
         * @param {number} id Identificador único
         * @param {ValidacionDocumental} validacionDocumental 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateValidacionDocumentalById(id: number, validacionDocumental: ValidacionDocumental, options?: any): AxiosPromise<ValidacionDocumental> {
            return localVarFp.updateValidacionDocumentalById(id, validacionDocumental, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidacionDocumentalApi - object-oriented interface
 * @export
 * @class ValidacionDocumentalApi
 * @extends {BaseAPI}
 */
export class ValidacionDocumentalApi extends BaseAPI {
    /**
     * 
     * @summary Crear una nueva validación documental
     * @param {ValidacionDocumental} validacionDocumental 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidacionDocumentalApi
     */
    public createValidacionDocumental(validacionDocumental: ValidacionDocumental, options?: AxiosRequestConfig) {
        return ValidacionDocumentalApiFp(this.configuration).createValidacionDocumental(validacionDocumental, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener todas las validaciones documentales
     * @param {number} [page] Page number
     * @param {number} [size] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidacionDocumentalApi
     */
    public getAllValidacionesDocumentales(page?: number, size?: number, options?: AxiosRequestConfig) {
        return ValidacionDocumentalApiFp(this.configuration).getAllValidacionesDocumentales(page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener validación documental por ID
     * @param {number} id Identificador único
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidacionDocumentalApi
     */
    public getValidacionDocumentalById(id: number, options?: AxiosRequestConfig) {
        return ValidacionDocumentalApiFp(this.configuration).getValidacionDocumentalById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener validaciones documentales por ID de solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidacionDocumentalApi
     */
    public getValidacionDocumentalByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig) {
        return ValidacionDocumentalApiFp(this.configuration).getValidacionDocumentalByIdSolicitud(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener historial de validaciones documentales por ID de solicitud
     * @param {number} idSolicitud Identificador único de la solicitud
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidacionDocumentalApi
     */
    public getValidacionDocumentalHistoricoByIdSolicitud(idSolicitud: number, options?: AxiosRequestConfig) {
        return ValidacionDocumentalApiFp(this.configuration).getValidacionDocumentalHistoricoByIdSolicitud(idSolicitud, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar validación documental por ID
     * @param {number} id Identificador único
     * @param {ValidacionDocumental} validacionDocumental 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidacionDocumentalApi
     */
    public updateValidacionDocumentalById(id: number, validacionDocumental: ValidacionDocumental, options?: AxiosRequestConfig) {
        return ValidacionDocumentalApiFp(this.configuration).updateValidacionDocumentalById(id, validacionDocumental, options).then((request) => request(this.axios, this.basePath));
    }
}


